var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-google-sitemap",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-google-sitemap:not(.animated) .animable {opacity: 0;}svg#freepik_stories-google-sitemap.animated #freepik--background-simple--inject-62 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-google-sitemap.animated #freepik--Device--inject-62 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-google-sitemap.animated #freepik--Plant--inject-62 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-google-sitemap.animated #freepik--Character--inject-62 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-google-sitemap.animated #freepik--Floor--inject-62 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-62",
    className: "animable",
    style: {
      transformOrigin: "364.419px 235.612px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.51,85.44c-26.7-43.5-74.69-63.12-119.94-60.89C494.93,26.2,454.79,40.12,427,72.67c-21.23,24.85-37.49,58.17-61.42,80.59-28.31,26.52-73.05,26.35-111.89,19.92s-79-17.34-116.84-6.56C99.46,177.27,70.34,209.33,61,245.93s.22,76.58,22.43,107.54,55.38,53.88,92.48,65.41l-.46-.18c104.9,39.83,232.62,34.23,329.37,2.89C559,404,583.32,389.47,613.89,345.12c20.87-30.28,40.72-69,49-104.52C675.2,187.78,677.09,132,648.51,85.44Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "364.419px 235.612px"
    },
    id: "elfappdzimer5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-62",
    className: "animable",
    style: {
      transformOrigin: "352.89px 277.605px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.14,76.89H125.64a14.18,14.18,0,0,0-14.19,14.18v321a14.19,14.19,0,0,0,14.19,14.19H300.07s11.1,34.31-23.3,52.06H439.88S401,465,411,426.29H580.14a14.19,14.19,0,0,0,14.19-14.19v-321A14.18,14.18,0,0,0,580.14,76.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.89px 277.605px"
    },
    id: "el4xb9bcepo5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,392.52c6.18,8.84-3.5,18.52-12.34,12.33a2.85,2.85,0,0,1-.75-.76c-6.17-8.83,3.49-18.49,12.33-12.33A3.42,3.42,0,0,1,359,392.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "352.456px 398.312px"
    },
    id: "el6rscnftrshq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,82.77H576.8a9.7,9.7,0,0,1,9.7,9.7V367.56a0,0,0,0,1,0,0H119.28a0,0,0,0,1,0,0V92.46a9.7,9.7,0,0,1,9.7-9.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "352.89px 225.16px"
    },
    id: "el7k70wlv37hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,108H119.15V91.92a9.15,9.15,0,0,1,9.15-9.15H578.86a7.51,7.51,0,0,1,7.51,7.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "352.825px 95.385px"
    },
    id: "elgf7322kvptp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.44,95.1a3.29,3.29,0,1,1-3.29-3.29A3.28,3.28,0,0,1,137.44,95.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "134.15px 95.1px"
    },
    id: "el38b09xxdnj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22,95.1a3.28,3.28,0,1,1-3.28-3.29A3.28,3.28,0,0,1,147.22,95.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "143.94px 95.09px"
    },
    id: "elbt9h27uzx4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53,95.1a3.29,3.29,0,1,1-3.29-3.29A3.28,3.28,0,0,1,156.53,95.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.24px 95.1px"
    },
    id: "elohufeiixym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.88,426.33c0,.15-64.67.27-144.44.27S210,426.48,210,426.33s64.66-.27,144.45-.27S498.88,426.18,498.88,426.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "354.44px 426.33px"
    },
    id: "el6x3uvvrqkul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.15,
    y: 143.56,
    width: 106.76,
    height: 220.79,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.53px 253.955px"
    },
    id: "eltx0pki1xdrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.15,
    y: 209.86,
    width: 106.76,
    height: 70.34,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "172.53px 245.03px"
    },
    id: "el448do4vh0ad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,340.05c0,.15-23.45.26-52.36.26s-52.37-.11-52.37-.26,23.44-.26,52.37-.26S224.11,339.91,224.11,340.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.745px 340.05px"
    },
    id: "el335fn76lnik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,280.19c0,.15-23.45.26-52.36.26s-52.37-.11-52.37-.26,23.44-.26,52.37-.26S224.11,280.05,224.11,280.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.745px 280.19px"
    },
    id: "el0gf8td49n2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.27,
    y: 252.08,
    width: 339.79,
    height: 17.08,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.165px 260.62px"
    },
    id: "el88afqa2hsij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.27,
    y: 179.16,
    width: 339.79,
    height: 65.43,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "405.165px 211.875px"
    },
    id: "elqbc21qouwue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.15,
    y: 107.99,
    width: 467.35,
    height: 35.56,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "352.825px 125.77px"
    },
    id: "el1jusycltaan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,122.25a58.13,58.13,0,0,1-7.85.26,58,58,0,0,1-7.84-.26,60.08,60.08,0,0,1,7.84-.26A60.17,60.17,0,0,1,147.78,122.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.935px 122.252px"
    },
    id: "elwidbmq08x3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,125.77a58.13,58.13,0,0,1-7.85.26,58,58,0,0,1-7.84-.26,60.08,60.08,0,0,1,7.84-.26A60.17,60.17,0,0,1,147.78,125.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.935px 125.772px"
    },
    id: "elk0mg8dy3j1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,129.3a60.17,60.17,0,0,1-7.85.26,60.08,60.08,0,0,1-7.84-.26,58,58,0,0,1,7.84-.26A58.13,58.13,0,0,1,147.78,129.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.935px 129.298px"
    },
    id: "elh1dythyknts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.52,133H262.58a8.85,8.85,0,0,1-8.85-8.86h0a8.86,8.86,0,0,1,8.85-8.86H511.52a8.86,8.86,0,0,1,8.86,8.86h0A8.86,8.86,0,0,1,511.52,133Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.055px 124.14px"
    },
    id: "el68stroczwyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,123.6c-.05,0-.05-.33-.22-.88a3.71,3.71,0,0,0-1.36-1.93,3.59,3.59,0,0,0-3.33-.46,3.5,3.5,0,1,0,3.33,6.08,3.69,3.69,0,0,0,1.36-1.92c.17-.56.17-.89.22-.89a1.93,1.93,0,0,1,0,.93,3.67,3.67,0,0,1-1.34,2.17,3.86,3.86,0,0,1-3.71.62,3.95,3.95,0,0,1,0-7.44,3.91,3.91,0,0,1,3.71.62,3.67,3.67,0,0,1,1.34,2.17A1.92,1.92,0,0,1,266.73,123.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.923px 123.603px"
    },
    id: "elp7tvdowk1fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.69,126.1c.1-.1.84.42,1.65,1.16s1.38,1.44,1.29,1.55-.84-.42-1.65-1.16S265.6,126.21,265.69,126.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.16px 127.456px"
    },
    id: "elbrjtvjgyzuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.91,
    y: 143.56,
    width: 360.6,
    height: 26.91,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "406.21px 157.015px"
    },
    id: "el8n57dr0po0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,239.58h-8.42v-8.42h8.42Zm-7.42-1h6.42v-6.42h-6.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "140.57px 235.37px"
    },
    id: "eloisxday9xl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,256.73h-8.42v-8.42h8.42Zm-7.42-1h6.42v-6.42h-6.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.42px 252.52px"
    },
    id: "elul55fhro2qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,247h-8.42v-8.43h8.42Zm-7.42-1h6.42v-6.43h-6.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.42px 242.785px"
    },
    id: "elf5v94sdq6zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.05 253.19 140.07 253.19 140.07 239.08 141.07 239.08 141.07 252.19 146.05 252.19 146.05 253.19",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.06px 246.135px"
    },
    id: "elxn6x3uq41dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.57,
    y: 243.34,
    width: 5.14,
    height: 1,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.14px 243.84px"
    },
    id: "elrkcs7ctcre8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,248l.39-.82a3.84,3.84,0,0,0,2.45.86c1.28,0,1.83-.5,1.83-1.15,0-1.81-4.49-.67-4.49-3.42,0-1.14.89-2.12,2.84-2.12a4.37,4.37,0,0,1,2.38.66l-.35.85a3.74,3.74,0,0,0-2-.61c-1.26,0-1.8.53-1.8,1.18,0,1.81,4.49.68,4.49,3.4,0,1.13-.91,2.11-2.87,2.11A4.43,4.43,0,0,1,157.43,248Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.3px 245.146px"
    },
    id: "elqxvom87qlph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,241.46a.67.67,0,0,1,.69-.67.67.67,0,1,1-.69.67Zm.18,1.74h1v5.61h-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.03px 244.8px"
    },
    id: "el06fc6oxo4z3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.65,248.48a1.91,1.91,0,0,1-1.23.39,1.59,1.59,0,0,1-1.78-1.75V244h-.95v-.83h.95V242h1v1.23h1.61V244h-1.61v3c0,.61.31,1,.87,1a1.29,1.29,0,0,0,.8-.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.67px 245.441px"
    },
    id: "elvk580uafsla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.73,246.34h-4.55a1.9,1.9,0,0,0,2,1.64,2.1,2.1,0,0,0,1.62-.67l.57.65a3.07,3.07,0,0,1-5.24-2,2.75,2.75,0,0,1,2.82-2.85,2.71,2.71,0,0,1,2.78,2.89C176.76,246.12,176.74,246.25,176.73,246.34Zm-4.55-.73h3.6a1.81,1.81,0,0,0-3.6,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.937px 245.986px"
    },
    id: "el740mzrziugx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.48,245.58v3.23h-1V245.7c0-1.1-.52-1.64-1.45-1.64a1.63,1.63,0,0,0-1.68,1.86v2.89h-1V245.7c0-1.1-.53-1.64-1.45-1.64a1.63,1.63,0,0,0-1.68,1.86v2.89h-1V243.2h1V244a2.26,2.26,0,0,1,1.93-.88,2.07,2.07,0,0,1,2,1,2.55,2.55,0,0,1,2.16-1A2.15,2.15,0,0,1,187.48,245.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.861px 245.959px"
    },
    id: "elb2chlhv1jsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8,245.42v3.39h-1v-.74a2.09,2.09,0,0,1-1.85.8c-1.27,0-2.07-.67-2.07-1.65s.58-1.64,2.25-1.64h1.61v-.2c0-.86-.49-1.36-1.5-1.36a2.86,2.86,0,0,0-1.78.61l-.42-.76a3.71,3.71,0,0,1,2.32-.72C192.93,243.15,193.8,243.89,193.8,245.42Zm-1,1.68v-.79h-1.56c-1,0-1.29.39-1.29.87s.46.91,1.23.91A1.62,1.62,0,0,0,192.78,247.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.34px 246.014px"
    },
    id: "ely54556qyktl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,246a2.73,2.73,0,0,1-2.84,2.87,2.39,2.39,0,0,1-2-.91v2.91h-1V243.2h1v.89a2.36,2.36,0,0,1,2-.94A2.72,2.72,0,0,1,201.5,246Zm-1,0a1.89,1.89,0,1,0-1.89,2A1.85,1.85,0,0,0,200.47,246Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.582px 247.009px"
    },
    id: "elwg43qicb86c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,248.22l.42-.81a3.61,3.61,0,0,0,2,.59c.94,0,1.33-.29,1.33-.77,0-1.26-3.54-.17-3.54-2.4,0-1,.9-1.68,2.34-1.68a4.16,4.16,0,0,1,2,.5l-.43.81a2.94,2.94,0,0,0-1.63-.45c-.88,0-1.32.33-1.32.78,0,1.32,3.56.24,3.56,2.42,0,1-.93,1.66-2.43,1.66A4,4,0,0,1,202.2,248.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.565px 246.011px"
    },
    id: "el2e9zpvdf3gv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.71,161.13l.41-.85a4,4,0,0,0,2.53.89c1.33,0,1.9-.52,1.9-1.19,0-1.87-4.65-.69-4.65-3.54,0-1.18.92-2.19,2.94-2.19a4.49,4.49,0,0,1,2.46.68l-.36.88a3.94,3.94,0,0,0-2.1-.63c-1.31,0-1.87.55-1.87,1.22,0,1.87,4.65.7,4.65,3.52,0,1.17-.94,2.18-3,2.18A4.58,4.58,0,0,1,239.71,161.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "242.665px 158.175px"
    },
    id: "elr9jlzsl0b88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,154.41a.71.71,0,0,1,1.42,0,.69.69,0,0,1-.71.71A.68.68,0,0,1,246.88,154.41Zm.18,1.79h1.05V162h-1.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "247.59px 157.85px"
    },
    id: "elc5ksivy6sbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,161.67a2,2,0,0,1-1.27.41,1.66,1.66,0,0,1-1.84-1.82v-3.19h-1v-.87h1v-1.27h1v1.27H253v.87h-1.67v3.14a.86.86,0,0,0,.91,1,1.29,1.29,0,0,0,.82-.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "251.325px 158.51px"
    },
    id: "elkaajp23yzz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,159.46H255a2,2,0,0,0,2.1,1.69,2.18,2.18,0,0,0,1.68-.7l.58.68a3.16,3.16,0,0,1-5.41-2,2.84,2.84,0,0,1,2.91-3,2.79,2.79,0,0,1,2.87,3C259.7,159.23,259.69,159.36,259.68,159.46ZM255,158.7h3.72a1.87,1.87,0,0,0-3.72,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "256.842px 159.104px"
    },
    id: "el090jqf98s79a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,158.67V162h-1.05v-3.22c0-1.14-.55-1.7-1.51-1.7A1.69,1.69,0,0,0,266.5,159v3h-1.05v-3.22c0-1.14-.55-1.7-1.5-1.7a1.69,1.69,0,0,0-1.74,1.93v3h-1V156.2h1v.87a2.37,2.37,0,0,1,2-.92,2.14,2.14,0,0,1,2,1.07,2.61,2.61,0,0,1,2.24-1.07A2.23,2.23,0,0,1,270.8,158.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "266.015px 159.078px"
    },
    id: "elrcrwxszl88q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.33,158.5V162h-1v-.77a2.17,2.17,0,0,1-1.91.84c-1.32,0-2.15-.71-2.15-1.71s.6-1.7,2.34-1.7h1.66v-.21c0-.89-.51-1.4-1.56-1.4a3,3,0,0,0-1.84.62l-.43-.79a3.86,3.86,0,0,1,2.4-.74C276.43,156.15,277.33,156.91,277.33,158.5Zm-1.05,1.73v-.81h-1.62c-1,0-1.34.41-1.34.9s.48.94,1.28.94A1.68,1.68,0,0,0,276.28,160.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "274.8px 159.108px"
    },
    id: "elxj0udixwxos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.29,159.11a2.82,2.82,0,0,1-2.93,3,2.48,2.48,0,0,1-2-1v3h-1.05V156.2h1v.92a2.48,2.48,0,0,1,2.07-1A2.81,2.81,0,0,1,285.29,159.11Zm-1.06,0a2,2,0,1,0-2,2A1.92,1.92,0,0,0,284.23,159.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.303px 160.114px"
    },
    id: "elvi9cqmvz46f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,161.4l.44-.84a3.75,3.75,0,0,0,2,.61c1,0,1.38-.3,1.38-.79,0-1.31-3.67-.18-3.67-2.49,0-1,.93-1.74,2.42-1.74a4.34,4.34,0,0,1,2.12.52l-.45.84a3,3,0,0,0-1.68-.46c-.92,0-1.37.34-1.37.8,0,1.37,3.68.25,3.68,2.5,0,1.06-1,1.73-2.51,1.73A4.25,4.25,0,0,1,286,161.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.435px 159.115px"
    },
    id: "elv1kocrpen5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.19,201.91h-4.41l-.91,2.07h-1.22l3.75-8.29h1.18l3.76,8.29H263.1Zm-.42-.95L260,196.9,258.2,201Z",
    id: "elmltnplwlh6",
    className: "animable",
    style: {
      transformOrigin: "259.995px 199.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.27,195.19V204h-1.09v-1a2.66,2.66,0,0,1-2.24,1.06,3.2,3.2,0,0,1,0-6.4,2.67,2.67,0,0,1,2.19,1v-3.46Zm-1.13,5.65a2.12,2.12,0,1,0-2.11,2.22A2.07,2.07,0,0,0,270.14,200.84Z",
    id: "el9rx5gh5844m",
    className: "animable",
    style: {
      transformOrigin: "268.008px 199.626px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.34,195.19V204h-1.09v-1a2.64,2.64,0,0,1-2.24,1.06,3.2,3.2,0,0,1,0-6.4,2.67,2.67,0,0,1,2.19,1v-3.46Zm-1.13,5.65a2.11,2.11,0,1,0-2.1,2.22A2.07,2.07,0,0,0,278.21,200.84Z",
    id: "eltzckr4gzj9",
    className: "animable",
    style: {
      transformOrigin: "276.078px 199.626px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,200.19V204h-1.08v-.83a2.33,2.33,0,0,1-2.06.9c-1.42,0-2.32-.76-2.32-1.85s.65-1.83,2.52-1.83h1.8v-.23c0-.95-.55-1.51-1.68-1.51a3.22,3.22,0,0,0-2,.67l-.47-.85a4.18,4.18,0,0,1,2.59-.8C288.68,197.65,289.65,198.47,289.65,200.19Zm-1.14,1.87v-.87h-1.75c-1.12,0-1.44.43-1.44,1s.52,1,1.38,1A1.82,1.82,0,0,0,288.51,202.06Z",
    id: "elazjxrky1pt",
    className: "animable",
    style: {
      transformOrigin: "286.92px 200.874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,200.37V204h-1.14V200.5c0-1.23-.62-1.84-1.69-1.84a1.87,1.87,0,0,0-2,2.09V204h-1.14v-6.27H296v.94a2.69,2.69,0,0,1,2.26-1A2.43,2.43,0,0,1,300.9,200.37Z",
    id: "el074jxr98dfl",
    className: "animable",
    style: {
      transformOrigin: "297.923px 200.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,201.22h-5.09a2.13,2.13,0,0,0,2.28,1.84,2.34,2.34,0,0,0,1.81-.76l.63.73a3.42,3.42,0,0,1-5.85-2.19,3.06,3.06,0,0,1,3.15-3.19,3,3,0,0,1,3.1,3.23A2,2,0,0,1,308.68,201.22Zm-5.09-.82h4a2,2,0,0,0-4,0Z",
    id: "elvqc4x8l3x3",
    className: "animable",
    style: {
      transformOrigin: "305.588px 200.849px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.66,197.71,317.31,204h-1.09l-1.81-4.76L312.58,204h-1.09l-2.33-6.27h1.07l1.83,5,1.89-5h1l1.86,5,1.87-5Z",
    id: "elzi3lggq0om",
    className: "animable",
    style: {
      transformOrigin: "314.41px 200.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.19,203.32l.48-.9a4,4,0,0,0,2.2.65c1.05,0,1.49-.32,1.49-.85,0-1.41-4-.19-4-2.69,0-1.13,1-1.88,2.61-1.88a4.65,4.65,0,0,1,2.29.56l-.49.9a3.32,3.32,0,0,0-1.81-.49c-1,0-1.48.36-1.48.86,0,1.48,4,.27,4,2.71,0,1.14-1,1.86-2.71,1.86A4.62,4.62,0,0,1,323.19,203.32Z",
    id: "elz9kgy0s3s6c",
    className: "animable",
    style: {
      transformOrigin: "325.835px 200.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,195.76a.77.77,0,1,1,.77.74A.75.75,0,0,1,329.72,195.76Zm.2,2h1.14V204h-1.14Z",
    id: "elxeh02ku9c2",
    className: "animable",
    style: {
      transformOrigin: "330.489px 199.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.75,203.61a2.1,2.1,0,0,1-1.37.44,1.79,1.79,0,0,1-2-2v-3.45h-1.07v-.93h1.07v-1.38h1.13v1.38h1.8v.93h-1.8V202a.93.93,0,0,0,1,1.05,1.39,1.39,0,0,0,.88-.29Z",
    id: "elrhh1b1qkfug",
    className: "animable",
    style: {
      transformOrigin: "334.53px 200.177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.56,201.22h-5.1a2.14,2.14,0,0,0,2.28,1.84,2.34,2.34,0,0,0,1.81-.76l.63.73a3.42,3.42,0,0,1-5.85-2.19,3.07,3.07,0,0,1,3.15-3.19,3,3,0,0,1,3.1,3.23C343.58,201,343.57,201.12,343.56,201.22Zm-5.1-.82h4a2,2,0,0,0-4,0Z",
    id: "elv3tro8io5en",
    className: "animable",
    style: {
      transformOrigin: "340.458px 200.849px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,200.37V204h-1.13V200.5c0-1.23-.6-1.84-1.63-1.84a1.83,1.83,0,0,0-1.88,2.09V204h-1.14V200.5c0-1.23-.59-1.84-1.62-1.84a1.83,1.83,0,0,0-1.88,2.09V204h-1.14v-6.27h1.09v.93a2.54,2.54,0,0,1,2.17-1,2.31,2.31,0,0,1,2.18,1.16,2.82,2.82,0,0,1,2.41-1.16A2.4,2.4,0,0,1,355.57,200.37Z",
    id: "elew72gt4fy1j",
    className: "animable",
    style: {
      transformOrigin: "350.371px 200.826px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,200.19V204h-1.08v-.83a2.33,2.33,0,0,1-2.06.9c-1.42,0-2.32-.76-2.32-1.85s.65-1.83,2.52-1.83h1.8v-.23c0-.95-.56-1.51-1.68-1.51a3.2,3.2,0,0,0-2,.67l-.47-.85a4.16,4.16,0,0,1,2.59-.8C361.67,197.65,362.64,198.47,362.64,200.19Zm-1.14,1.87v-.87h-1.75c-1.13,0-1.45.43-1.45,1s.53,1,1.39,1A1.82,1.82,0,0,0,361.5,202.06Z",
    id: "elca9617z2g4f",
    className: "animable",
    style: {
      transformOrigin: "359.91px 200.874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.24,200.84a3,3,0,0,1-3.17,3.21,2.66,2.66,0,0,1-2.19-1v3.25h-1.14v-8.57h1.09v1a2.68,2.68,0,0,1,2.24-1A3,3,0,0,1,371.24,200.84Zm-1.14,0a2.12,2.12,0,1,0-2.12,2.22A2.08,2.08,0,0,0,370.1,200.84Z",
    id: "el439qhwfejkq",
    className: "animable",
    style: {
      transformOrigin: "367.994px 202.013px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,364.34c-.15,0-.26-48.73-.26-108.84s.11-108.84.26-108.84.26,48.72.26,108.84S226.05,364.34,225.91,364.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.91px 255.5px"
    },
    id: "elzhdxc20cnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,220.67l.36-.68a3.08,3.08,0,0,0,1.68.49c.8,0,1.14-.24,1.14-.65,0-1.07-3-.14-3-2.05,0-.85.77-1.43,2-1.43a3.47,3.47,0,0,1,1.74.43l-.37.69a2.49,2.49,0,0,0-1.38-.38c-.76,0-1.13.28-1.13.66,0,1.13,3,.21,3,2.07,0,.86-.8,1.41-2.07,1.41A3.43,3.43,0,0,1,255.88,220.67Z",
    id: "elazd4upjf2ql",
    className: "animable",
    style: {
      transformOrigin: "257.9px 218.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.86,214.91a.57.57,0,0,1,.58-.57.57.57,0,1,1,0,1.13A.56.56,0,0,1,260.86,214.91Zm.15,1.48h.87v4.79H261Z",
    id: "elg43ypphcot",
    className: "animable",
    style: {
      transformOrigin: "261.473px 217.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,220.9a1.61,1.61,0,0,1-1.05.33,1.37,1.37,0,0,1-1.52-1.5v-2.62h-.81v-.72h.81v-1h.87v1h1.37v.72h-1.37v2.59a.7.7,0,0,0,.75.8,1.13,1.13,0,0,0,.68-.22Z",
    id: "elwdws0jykqbl",
    className: "animable",
    style: {
      transformOrigin: "264.53px 218.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41,219.08h-3.88a1.62,1.62,0,0,0,1.73,1.4,1.81,1.81,0,0,0,1.39-.58l.47.56a2.61,2.61,0,0,1-4.46-1.67,2.34,2.34,0,0,1,2.4-2.44,2.3,2.3,0,0,1,2.37,2.46A2.65,2.65,0,0,1,271.41,219.08Zm-3.88-.63h3.07a1.54,1.54,0,0,0-3.07,0Z",
    id: "el4q87ywdjdet",
    className: "animable",
    style: {
      transformOrigin: "269.047px 218.791px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58,218.43v2.75h-.87v-2.66c0-.94-.45-1.4-1.23-1.4a1.4,1.4,0,0,0-1.44,1.59v2.47h-.87v-2.66c0-.94-.45-1.4-1.24-1.4a1.39,1.39,0,0,0-1.43,1.59v2.47h-.87v-4.79h.83v.72a2,2,0,0,1,1.66-.76,1.78,1.78,0,0,1,1.66.88,2.16,2.16,0,0,1,1.84-.88A1.83,1.83,0,0,1,280.58,218.43Z",
    id: "el0ciwgni1xum",
    className: "animable",
    style: {
      transformOrigin: "276.614px 218.762px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,218.29v2.89h-.82v-.63a1.78,1.78,0,0,1-1.57.68c-1.09,0-1.77-.57-1.77-1.4s.49-1.4,1.92-1.4h1.37v-.18c0-.73-.42-1.15-1.28-1.15a2.46,2.46,0,0,0-1.52.51l-.36-.65a3.18,3.18,0,0,1,2-.61C285.23,216.35,286,217,286,218.29Zm-.87,1.43v-.67h-1.33c-.86,0-1.11.33-1.11.74s.4.78,1.06.78A1.38,1.38,0,0,0,285.1,219.72Z",
    id: "el290i26wdtfu",
    className: "animable",
    style: {
      transformOrigin: "283.92px 218.793px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,218.79a2.33,2.33,0,0,1-2.43,2.44,2.06,2.06,0,0,1-1.67-.77v2.47h-.86v-6.54h.83v.76a2,2,0,0,1,1.7-.8A2.33,2.33,0,0,1,292.54,218.79Zm-.88,0a1.62,1.62,0,1,0-1.62,1.69A1.58,1.58,0,0,0,291.66,218.79Z",
    id: "elbownaw5lhp4",
    className: "animable",
    style: {
      transformOrigin: "290.061px 219.639px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.67,221.18h4.52v.56h-4.52Z",
    id: "el2t5nq6vnfwj",
    className: "animable",
    style: {
      transformOrigin: "294.93px 221.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.85,214.91a.58.58,0,0,1,.59-.57.57.57,0,1,1-.59.57Zm.16,1.48h.86v4.79H298Z",
    id: "elakc3r9wp7im",
    className: "animable",
    style: {
      transformOrigin: "298.42px 217.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07,218.43v2.75h-.87v-2.66c0-.94-.47-1.4-1.29-1.4a1.43,1.43,0,0,0-1.52,1.59v2.47h-.86v-4.79h.83v.73a2,2,0,0,1,1.72-.77A1.86,1.86,0,0,1,305.07,218.43Z",
    id: "el7w23owmoqsg",
    className: "animable",
    style: {
      transformOrigin: "302.807px 218.762px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,214.48v6.7h-.83v-.76a2,2,0,0,1-1.71.81,2.44,2.44,0,0,1,0-4.88,2,2,0,0,1,1.67.77v-2.64Zm-.86,4.31a1.61,1.61,0,1,0-1.61,1.69A1.57,1.57,0,0,0,310.36,218.79Z",
    id: "elyk7plwum3cp",
    className: "animable",
    style: {
      transformOrigin: "308.73px 217.856px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,219.08h-3.88a1.62,1.62,0,0,0,1.73,1.4,1.78,1.78,0,0,0,1.38-.58l.48.56a2.61,2.61,0,0,1-4.46-1.67,2.34,2.34,0,0,1,2.4-2.44,2.31,2.31,0,0,1,2.37,2.46A2.65,2.65,0,0,1,317.17,219.08Zm-3.88-.63h3.07a1.54,1.54,0,0,0-3.07,0Z",
    id: "el0cpw5jp7rc5n",
    className: "animable",
    style: {
      transformOrigin: "314.806px 218.792px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,221.18l-1.39-1.83-1.4,1.83h-1l1.89-2.45-1.8-2.34h1l1.32,1.73,1.31-1.73h.95l-1.81,2.34,1.91,2.45Z",
    id: "elxq58yxwk6m",
    className: "animable",
    style: {
      transformOrigin: "319.905px 218.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.83,220.61a.6.6,0,0,1,.62-.61.59.59,0,0,1,.59.61.6.6,0,0,1-.59.62A.61.61,0,0,1,322.83,220.61Z",
    id: "eln7csx3s0nxm",
    className: "animable",
    style: {
      transformOrigin: "323.435px 220.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,221.18,327,219.35l-1.4,1.83h-1l1.89-2.45-1.8-2.34h1l1.32,1.73,1.31-1.73h1l-1.81,2.34,1.91,2.45Z",
    id: "elfvz3x1lx7v6",
    className: "animable",
    style: {
      transformOrigin: "327.01px 218.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.22,218.43v2.75h-.87v-2.66c0-.94-.45-1.4-1.23-1.4a1.4,1.4,0,0,0-1.44,1.59v2.47h-.87v-2.66c0-.94-.45-1.4-1.23-1.4a1.4,1.4,0,0,0-1.44,1.59v2.47h-.87v-4.79h.83v.72a2,2,0,0,1,1.66-.76,1.78,1.78,0,0,1,1.66.88,2.16,2.16,0,0,1,1.84-.88A1.83,1.83,0,0,1,338.22,218.43Z",
    id: "el5mtf9fua0yk",
    className: "animable",
    style: {
      transformOrigin: "334.254px 218.762px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.82,214.48h.86v6.7h-.86Z",
    id: "el4qv4up2gv44",
    className: "animable",
    style: {
      transformOrigin: "340.25px 217.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,262.88l.26-.48a2.16,2.16,0,0,0,1.18.34c.56,0,.79-.17.79-.45,0-.76-2.12-.1-2.12-1.44,0-.6.54-1,1.4-1a2.42,2.42,0,0,1,1.22.31l-.26.48a1.71,1.71,0,0,0-1-.27c-.54,0-.8.2-.8.47,0,.79,2.13.14,2.13,1.45,0,.6-.56,1-1.45,1A2.44,2.44,0,0,1,255.81,262.88Z",
    id: "elu85hk2p3ck",
    className: "animable",
    style: {
      transformOrigin: "257.21px 261.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,258.84a.4.4,0,0,1,.41-.4.39.39,0,0,1,.41.38.4.4,0,0,1-.41.41A.4.4,0,0,1,259.3,258.84Zm.11,1H260v3.35h-.61Z",
    id: "elcjf2dxwju5d",
    className: "animable",
    style: {
      transformOrigin: "259.71px 260.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,263a1.19,1.19,0,0,1-.74.23,1,1,0,0,1-1.06-1v-1.84h-.57v-.5h.57v-.74h.61v.74h1v.5h-1v1.81a.5.5,0,0,0,.52.57.79.79,0,0,0,.48-.16Z",
    id: "elayeso8uhq5s",
    className: "animable",
    style: {
      transformOrigin: "261.875px 261.191px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.7,261.76H264a1.13,1.13,0,0,0,1.21,1,1.28,1.28,0,0,0,1-.41l.34.39a1.83,1.83,0,0,1-3.13-1.17,1.64,1.64,0,0,1,1.68-1.71,1.62,1.62,0,0,1,1.66,1.73C266.71,261.62,266.7,261.7,266.7,261.76Zm-2.72-.44h2.15a1.05,1.05,0,0,0-1.08-1A1,1,0,0,0,264,261.32Z",
    id: "el29lpvvtv9m3",
    className: "animable",
    style: {
      transformOrigin: "265.091px 261.573px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.12,261.3v1.93h-.61v-1.86c0-.66-.31-1-.86-1a1,1,0,0,0-1,1.11v1.73H270v-1.86c0-.66-.32-1-.87-1a1,1,0,0,0-1,1.11v1.73h-.61v-3.35h.58v.5a1.34,1.34,0,0,1,1.16-.54,1.26,1.26,0,0,1,1.17.63,1.51,1.51,0,0,1,1.29-.63A1.29,1.29,0,0,1,273.12,261.3Z",
    id: "elibnn0hogau",
    className: "animable",
    style: {
      transformOrigin: "270.329px 261.512px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.89,261.21v2h-.57v-.44a1.25,1.25,0,0,1-1.1.48c-.76,0-1.25-.41-1.25-1s.35-1,1.35-1h1v-.12c0-.51-.3-.81-.9-.81a1.72,1.72,0,0,0-1.07.36l-.25-.46a2.3,2.3,0,0,1,1.39-.43A1.25,1.25,0,0,1,276.89,261.21Zm-.6,1v-.47h-.94c-.6,0-.77.23-.77.52s.28.54.74.54A1,1,0,0,0,276.29,262.21Z",
    id: "el6y2z2w66xv",
    className: "animable",
    style: {
      transformOrigin: "275.437px 261.517px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.49,261.55a1.62,1.62,0,0,1-1.69,1.72,1.39,1.39,0,0,1-1.17-.55v1.74H278v-4.58h.58v.53a1.41,1.41,0,0,1,1.2-.57A1.63,1.63,0,0,1,281.49,261.55Zm-.61,0a1.13,1.13,0,1,0-1.13,1.19A1.11,1.11,0,0,0,280.88,261.55Z",
    id: "elyhyennj31dp",
    className: "animable",
    style: {
      transformOrigin: "279.747px 262.149px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.58,263.23h3.17v.39h-3.17Z",
    id: "el40cayhaze3s",
    className: "animable",
    style: {
      transformOrigin: "283.165px 263.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,258.84a.41.41,0,1,1,.41.39A.39.39,0,0,1,285.22,258.84Zm.1,1h.61v3.35h-.61Z",
    id: "elg1zfdldwhyc",
    className: "animable",
    style: {
      transformOrigin: "285.63px 260.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,261.3v1.93h-.6v-1.86c0-.66-.33-1-.91-1a1,1,0,0,0-1.06,1.11v1.73h-.61v-3.35h.58v.5a1.45,1.45,0,0,1,1.21-.54A1.3,1.3,0,0,1,290.27,261.3Z",
    id: "el04g8lbs3j5eg",
    className: "animable",
    style: {
      transformOrigin: "288.687px 261.523px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,258.53v4.7H294v-.53a1.41,1.41,0,0,1-1.2.57,1.72,1.72,0,0,1,0-3.43,1.42,1.42,0,0,1,1.17.54v-1.85Zm-.6,3a1.13,1.13,0,1,0-2.26,0,1.13,1.13,0,1,0,2.26,0Z",
    id: "elawhl5ssv71t",
    className: "animable",
    style: {
      transformOrigin: "292.896px 260.901px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75,261.76H296a1.13,1.13,0,0,0,1.21,1,1.28,1.28,0,0,0,1-.41l.34.39a1.83,1.83,0,0,1-3.13-1.17,1.64,1.64,0,0,1,1.68-1.71,1.62,1.62,0,0,1,1.66,1.73A1.28,1.28,0,0,1,298.75,261.76Zm-2.72-.44h2.15a1.08,1.08,0,0,0-2.15,0Z",
    id: "elthfiuh8mo6c",
    className: "animable",
    style: {
      transformOrigin: "297.091px 261.573px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.65,263.23l-1-1.28-1,1.28H299l1.32-1.71-1.26-1.64h.68l.92,1.21.92-1.21h.67L301,261.52l1.34,1.71Z",
    id: "elvpu6r7qpiq",
    className: "animable",
    style: {
      transformOrigin: "300.67px 261.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,262.83a.43.43,0,0,1,.43-.43.44.44,0,0,1,0,.87A.43.43,0,0,1,302.71,262.83Z",
    id: "elob1c6tebr6i",
    className: "animable",
    style: {
      transformOrigin: "303.112px 262.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57,263.23l-1-1.28-1,1.28h-.68l1.33-1.71L304,259.88h.68l.92,1.21.92-1.21h.66l-1.26,1.64,1.33,1.71Z",
    id: "eli8ai2w6ic",
    className: "animable",
    style: {
      transformOrigin: "305.57px 261.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,261.3v1.93h-.61v-1.86c0-.66-.32-1-.87-1a1,1,0,0,0-1,1.11v1.73h-.6v-1.86c0-.66-.32-1-.87-1a1,1,0,0,0-1,1.11v1.73h-.61v-3.35h.59v.5a1.34,1.34,0,0,1,1.16-.54,1.24,1.24,0,0,1,1.16.63,1.51,1.51,0,0,1,1.29-.63A1.29,1.29,0,0,1,313.5,261.3Z",
    id: "el81m8k3k6b",
    className: "animable",
    style: {
      transformOrigin: "310.729px 261.513px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.61,258.53h.61v4.7h-.61Z",
    id: "ele635s5egw3i",
    className: "animable",
    style: {
      transformOrigin: "314.915px 260.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,262.86l.25-.48a2.19,2.19,0,0,0,1.18.35c.56,0,.8-.17.8-.46,0-.75-2.12-.1-2.12-1.44,0-.6.53-1,1.4-1a2.45,2.45,0,0,1,1.22.3l-.26.48a1.82,1.82,0,0,0-1-.26c-.53,0-.79.19-.79.46,0,.79,2.13.14,2.13,1.45,0,.61-.56,1-1.45,1A2.44,2.44,0,0,1,438,262.86Z",
    id: "el45q95v2yy4g",
    className: "animable",
    style: {
      transformOrigin: "439.405px 261.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.43,258.82a.41.41,0,0,1,.42-.4.4.4,0,1,1-.42.4Zm.11,1h.61v3.36h-.61Z",
    id: "el1cz1l2ioo3q",
    className: "animable",
    style: {
      transformOrigin: "441.83px 260.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.19,263a1.12,1.12,0,0,1-.73.23,1,1,0,0,1-1.06-1.05v-1.84h-.58v-.5h.58v-.74h.6v.74h1v.5h-1v1.82a.49.49,0,0,0,.53.56.74.74,0,0,0,.47-.16Z",
    id: "elhmfau7xdroa",
    className: "animable",
    style: {
      transformOrigin: "444.005px 261.166px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,261.74h-2.72a1.13,1.13,0,0,0,1.21,1,1.24,1.24,0,0,0,1-.4l.34.39a1.71,1.71,0,0,1-1.32.54,1.68,1.68,0,0,1-1.81-1.71,1.64,1.64,0,0,1,1.69-1.71,1.61,1.61,0,0,1,1.65,1.73A1.15,1.15,0,0,1,448.83,261.74Zm-2.72-.44h2.15a1.08,1.08,0,0,0-2.15,0Z",
    id: "elcubkmivhu15",
    className: "animable",
    style: {
      transformOrigin: "447.201px 261.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.25,261.28v1.94h-.6v-1.87c0-.66-.32-1-.87-1a1,1,0,0,0-1,1.12v1.73h-.61v-1.87c0-.66-.31-1-.86-1a1,1,0,0,0-1,1.12v1.73h-.61v-3.36h.59v.5a1.35,1.35,0,0,1,1.15-.53,1.24,1.24,0,0,1,1.17.62,1.5,1.5,0,0,1,1.29-.62A1.28,1.28,0,0,1,455.25,261.28Z",
    id: "elukzkcezgirg",
    className: "animable",
    style: {
      transformOrigin: "452.484px 261.503px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,261.19v2h-.58v-.45a1.22,1.22,0,0,1-1.1.48c-.76,0-1.24-.4-1.24-1s.35-1,1.35-1h1v-.12c0-.51-.3-.81-.9-.81a1.69,1.69,0,0,0-1.06.36l-.26-.45a2.24,2.24,0,0,1,1.39-.43C458.51,259.83,459,260.27,459,261.19Zm-.61,1v-.47h-.94c-.6,0-.77.24-.77.52s.28.54.74.54A1,1,0,0,0,458.42,262.19Z",
    id: "eld3siem7s8l8",
    className: "animable",
    style: {
      transformOrigin: "457.54px 261.498px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.63,261.54a1.63,1.63,0,0,1-1.7,1.71,1.44,1.44,0,0,1-1.17-.54v1.73h-.61v-4.58h.58v.53a1.46,1.46,0,0,1,1.2-.56A1.63,1.63,0,0,1,463.63,261.54Zm-.62,0a1.13,1.13,0,1,0-1.13,1.18A1.11,1.11,0,0,0,463,261.54Z",
    id: "el6frib414j6r",
    className: "animable",
    style: {
      transformOrigin: "461.891px 262.134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.06,258.82a.4.4,0,0,1,.41-.4.4.4,0,1,1-.41.4Zm.11,1h.61v3.36h-.61Z",
    id: "elnq62bxcuvzr",
    className: "animable",
    style: {
      transformOrigin: "466.46px 260.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.12,261.28v1.94h-.61v-1.87c0-.66-.33-1-.91-1a1,1,0,0,0-1.06,1.12v1.73h-.61v-3.36h.58v.51a1.43,1.43,0,0,1,1.21-.54A1.3,1.3,0,0,1,471.12,261.28Z",
    id: "elgs1c4l5ra4v",
    className: "animable",
    style: {
      transformOrigin: "469.531px 261.513px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.42,258.52v4.7h-.58v-.54a1.41,1.41,0,0,1-1.2.57,1.71,1.71,0,0,1,0-3.42,1.44,1.44,0,0,1,1.18.54v-1.85Zm-.6,3a1.13,1.13,0,1,0-1.13,1.18A1.11,1.11,0,0,0,474.82,261.54Z",
    id: "elto156kmm4yt",
    className: "animable",
    style: {
      transformOrigin: "473.675px 260.886px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.59,261.74h-2.72a1.14,1.14,0,0,0,1.22,1,1.23,1.23,0,0,0,1-.4l.34.39a1.69,1.69,0,0,1-1.32.54,1.68,1.68,0,0,1-1.81-1.71,1.64,1.64,0,0,1,1.69-1.71,1.62,1.62,0,0,1,1.66,1.73A1.24,1.24,0,0,1,479.59,261.74Zm-2.72-.44H479a1.08,1.08,0,0,0-2.15,0Z",
    id: "elvm31mhphlep",
    className: "animable",
    style: {
      transformOrigin: "477.976px 261.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.49,263.22l-1-1.29-1,1.29h-.68l1.32-1.72-1.26-1.64h.68l.93,1.21.91-1.21h.67l-1.27,1.64,1.34,1.72Z",
    id: "elafx3ziqg1g7",
    className: "animable",
    style: {
      transformOrigin: "481.47px 261.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,262.71l.23-.49a2.32,2.32,0,0,0,1.46.51c.77,0,1.1-.3,1.1-.69,0-1.08-2.69-.4-2.69-2,0-.69.54-1.27,1.7-1.27a2.66,2.66,0,0,1,1.43.39l-.21.51a2.29,2.29,0,0,0-1.22-.36c-.75,0-1.07.32-1.07.7,0,1.09,2.68.41,2.68,2,0,.67-.54,1.26-1.72,1.26A2.61,2.61,0,0,1,500,262.71Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "501.705px 261.02px"
    },
    id: "el7kbtsm200pt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.4,259.86v3.36h-.58v-.51a1.34,1.34,0,0,1-1.14.54,1.32,1.32,0,0,1-1.44-1.46v-1.93h.61v1.86c0,.66.33,1,.9,1a1,1,0,0,0,1-1.12v-1.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "505.816px 261.558px"
    },
    id: "el984z573tesh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.24,261.54a1.68,1.68,0,0,1,1.78-1.71,1.47,1.47,0,0,1,1.36.71l-.46.3a1,1,0,0,0-.91-.48,1.18,1.18,0,0,0,0,2.36,1,1,0,0,0,.91-.48l.46.29a1.48,1.48,0,0,1-1.36.72A1.68,1.68,0,0,1,508.24,261.54Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "509.81px 261.54px"
    },
    id: "el5qrchycu9a2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.14,261.74h-2.73a1.14,1.14,0,0,0,1.22,1,1.27,1.27,0,0,0,1-.4l.33.39a1.83,1.83,0,0,1-3.13-1.17,1.64,1.64,0,0,1,1.69-1.71,1.62,1.62,0,0,1,1.66,1.73C515.15,261.61,515.14,261.68,515.14,261.74Zm-2.73-.44h2.16a1.09,1.09,0,0,0-2.16,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "513.506px 261.562px"
    },
    id: "elrlemfbitvxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.56,262.86l.26-.48a2.16,2.16,0,0,0,1.17.35c.57,0,.8-.17.8-.46,0-.75-2.12-.1-2.12-1.44,0-.6.54-1,1.4-1a2.42,2.42,0,0,1,1.22.3l-.26.48a1.79,1.79,0,0,0-1-.26c-.53,0-.79.19-.79.46,0,.79,2.13.14,2.13,1.45,0,.61-.56,1-1.45,1A2.44,2.44,0,0,1,515.56,262.86Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "516.965px 261.545px"
    },
    id: "elpyjxq9uhk5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.73,262.86l.25-.48a2.22,2.22,0,0,0,1.18.35c.57,0,.8-.17.8-.46,0-.75-2.12-.1-2.12-1.44,0-.6.54-1,1.4-1a2.45,2.45,0,0,1,1.22.3l-.26.48a1.79,1.79,0,0,0-1-.26c-.53,0-.79.19-.79.46,0,.79,2.13.14,2.13,1.45,0,.61-.56,1-1.45,1A2.44,2.44,0,0,1,518.73,262.86Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "520.135px 261.545px"
    },
    id: "elwsw92dq3b9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.15,225.31H481.82a12.41,12.41,0,0,1-12.41-12.4h0a12.41,12.41,0,0,1,12.41-12.4h51.33a12.4,12.4,0,0,1,12.4,12.4h0A12.4,12.4,0,0,1,533.15,225.31Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "507.48px 212.91px"
    },
    id: "el98hzu583j1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.55,214.77l.38-.86a3.32,3.32,0,0,0,2,.65c.92,0,1.31-.33,1.31-.77,0-1.28-3.53-.44-3.53-2.65,0-1,.76-1.78,2.39-1.78a3.75,3.75,0,0,1,2,.53l-.35.86a3.23,3.23,0,0,0-1.63-.47c-.92,0-1.3.36-1.3.81,0,1.26,3.53.44,3.53,2.62,0,.95-.77,1.77-2.4,1.77A3.86,3.86,0,0,1,490.55,214.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "492.95px 212.421px"
    },
    id: "elbrsno5pl32",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.35,212.8v-3.35h1.1v3.31c0,1.22.55,1.75,1.51,1.75s1.51-.53,1.51-1.75v-3.31h1.09v3.35a2.61,2.61,0,1,1-5.21,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "498.955px 212.511px"
    },
    id: "elxyp388c8848",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.39,213.78c0,1-.8,1.61-2.33,1.61h-3v-5.94h2.79c1.43,0,2.19.6,2.19,1.54a1.43,1.43,0,0,1-.76,1.31A1.48,1.48,0,0,1,508.39,213.78Zm-4.19-3.47V212h1.57c.76,0,1.2-.27,1.2-.81s-.44-.83-1.2-.83Zm3.07,3.36c0-.6-.45-.86-1.28-.86H504.2v1.72H506C506.82,214.53,507.27,214.26,507.27,213.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "505.725px 212.42px"
    },
    id: "el2ff04b7unyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515,215.39v-3.94l-2,3.27h-.49l-2-3.22v3.89h-1.05v-5.94h.91l2.36,3.94,2.32-3.94h.91v5.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "512.71px 212.42px"
    },
    id: "el60wy88yzl5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.68,209.45h1.11v5.94h-1.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "518.235px 212.42px"
    },
    id: "elspefy192ga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.6,210.38h-2v-.93h5v.93h-2v5H521.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "522.1px 212.415px"
    },
    id: "elwq4ubnpcks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.09,
    y: 312.62,
    width: 39.47,
    height: 46.46,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "388.825px 335.85px"
    },
    id: "elyp5fvtioymg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.56,
    y: 325.62,
    width: 39.47,
    height: 33.46,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.295px 342.35px"
    },
    id: "elv1lxskhklk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.16,
    y: 289.27,
    width: 39.47,
    height: 69.81,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "291.895px 324.175px"
    },
    id: "elpgg7q54gmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.63,
    y: 276.64,
    width: 39.47,
    height: 82.44,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "340.365px 317.86px"
    },
    id: "eltper4s2tl48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.03,
    y: 342.35,
    width: 39.47,
    height: 16.73,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "485.765px 350.715px"
    },
    id: "elvwi63t347c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.49,
    y: 307.64,
    width: 39.47,
    height: 51.44,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "534.225px 333.36px"
    },
    id: "elu2icb9utzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.46,276.64l-.83,0-2.45,0-9.41.05-34.61.08L403,276.9l-114.22-.08-34.61-.08-9.41-.05-2.45,0-.83,0,.83,0,2.45,0,9.41-.05,34.61-.08L403,276.37l114.2.08,34.61.08,9.41.05,2.45,0h.63C564.39,276.63,564.47,276.63,564.46,276.64Z",
    id: "elptomg211z1m",
    className: "animable",
    style: {
      transformOrigin: "402.97px 276.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.46,298.05l-.83,0-2.45,0-9.41,0-34.61.08-114.2.08-114.22-.08-34.61-.08-9.41,0-2.45,0-.83,0,.83,0,2.45,0,9.41-.05,34.61-.09L403,297.79l114.2.07,34.61.09,9.41.05,2.45,0,.63,0C564.39,298,564.47,298,564.46,298.05Z",
    id: "el4zyqpm7lmlr",
    className: "animable",
    style: {
      transformOrigin: "402.95px 298px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.46,319.46l-.83,0-2.45,0-9.41,0-34.61.09-114.2.07-114.22-.07-34.61-.09-9.41,0-2.45,0-.83,0,.83,0,2.45,0,9.41-.05,34.61-.08L403,319.2l114.2.08,34.61.08,9.41.05,2.45,0h.83Z",
    id: "elavb95uqtfjr",
    className: "animable",
    style: {
      transformOrigin: "402.97px 319.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.46,340.88l-.83,0-2.45,0-9.41.05-34.61.08-114.2.08-114.22-.08L254.13,341l-9.41-.05-2.45,0-.83,0,.83,0,2.45,0,9.41,0,34.61-.09L403,340.62l114.2.07,34.61.09,9.41,0,2.45,0h.63C564.39,340.87,564.47,340.87,564.46,340.88Z",
    id: "elgzs29tjnatk",
    className: "animable",
    style: {
      transformOrigin: "402.95px 340.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.51,359.08l-.83,0-2.44,0-9.38.05-34.51.08-113.86.08-113.88-.08-34.52-.08-9.38-.05-2.44,0-.83,0,.83,0,2.44,0,9.38,0,34.52-.09,113.88-.07,113.86.07,34.51.09,9.38,0,2.44,0h.63C563.44,359.07,563.52,359.07,563.51,359.08Z",
    id: "el298qs8mgxkt",
    className: "animable",
    style: {
      transformOrigin: "402.475px 359.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.37,347v.48h-2.72v-.37l1.54-1.49c.4-.39.48-.63.48-.87,0-.39-.28-.63-.81-.63a1.19,1.19,0,0,0-1,.42l-.37-.32a1.75,1.75,0,0,1,1.39-.58c.79,0,1.3.41,1.3,1.06a1.54,1.54,0,0,1-.62,1.19L245.43,347Z",
    id: "elhqcsx4tng4r",
    className: "animable",
    style: {
      transformOrigin: "245.93px 345.559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,345.55c0-1.23.66-1.94,1.55-1.94s1.54.71,1.54,1.94-.66,1.94-1.54,1.94S247.8,346.79,247.8,345.55Zm2.55,0c0-1-.41-1.46-1-1.46s-1,.49-1,1.46.41,1.46,1,1.46S250.35,346.52,250.35,345.55Z",
    id: "elr60v54gcmxm",
    className: "animable",
    style: {
      transformOrigin: "249.345px 345.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.41,345.55c0-1.23.67-1.94,1.55-1.94s1.55.71,1.55,1.94-.66,1.94-1.55,1.94S251.41,346.79,251.41,345.55Zm2.56,0c0-1-.42-1.46-1-1.46s-1,.49-1,1.46.41,1.46,1,1.46S254,346.52,254,345.55Z",
    id: "elvaifxizjgbr",
    className: "animable",
    style: {
      transformOrigin: "252.96px 345.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,324.68h-.72v.94h-.53v-.94h-2.11v-.37l1.94-2.49h.59l-1.86,2.4h1.46v-.83h.51v.83H248Z",
    id: "elzp93gtfhs57",
    className: "animable",
    style: {
      transformOrigin: "246.32px 323.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,323.72c0-1.24.66-1.94,1.55-1.94s1.54.7,1.54,1.94-.66,1.94-1.54,1.94S248.33,325,248.33,323.72Zm2.55,0c0-1-.41-1.46-1-1.46s-1,.49-1,1.46.42,1.46,1,1.46S250.88,324.69,250.88,323.72Z",
    id: "elj2unbh760vi",
    className: "animable",
    style: {
      transformOrigin: "249.875px 323.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,323.72c0-1.24.66-1.94,1.54-1.94s1.55.7,1.55,1.94-.66,1.94-1.55,1.94S252,325,252,323.72Zm2.55,0c0-1-.41-1.46-1-1.46s-1,.49-1,1.46.41,1.46,1,1.46S254.5,324.69,254.5,323.72Z",
    id: "elsoexncyclvc",
    className: "animable",
    style: {
      transformOrigin: "253.545px 323.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.64,304.13a1.22,1.22,0,0,1-1.34,1.19c-1,0-1.59-.68-1.59-1.89a1.75,1.75,0,0,1,1.79-2,1.73,1.73,0,0,1,.94.23l-.2.42a1.34,1.34,0,0,0-.73-.18c-.77,0-1.26.48-1.26,1.43a.71.71,0,0,0,0,.14,1.23,1.23,0,0,1,1.08-.5A1.17,1.17,0,0,1,247.64,304.13Zm-.52,0c0-.45-.34-.73-.87-.73a.79.79,0,0,0-.87.73c0,.39.31.73.9.73A.75.75,0,0,0,247.12,304.15Z",
    id: "el6lq5yw1ublb",
    className: "animable",
    style: {
      transformOrigin: "246.166px 303.377px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05,303.38c0-1.23.66-1.94,1.55-1.94s1.54.71,1.54,1.94-.66,1.94-1.54,1.94S248.05,304.62,248.05,303.38Zm2.55,0c0-1-.41-1.45-1-1.45s-1,.48-1,1.45.41,1.46,1,1.46S250.6,304.35,250.6,303.38Z",
    id: "elvxz85ss3gbh",
    className: "animable",
    style: {
      transformOrigin: "249.595px 303.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,303.38c0-1.23.66-1.94,1.55-1.94s1.55.71,1.55,1.94-.66,1.94-1.55,1.94S251.66,304.62,251.66,303.38Zm2.55,0c0-1-.41-1.45-1-1.45s-1,.48-1,1.45.41,1.46,1,1.46S254.21,304.35,254.21,303.38Z",
    id: "elr5lbs8u00d",
    className: "animable",
    style: {
      transformOrigin: "253.21px 303.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7,282.19c0,.69-.59,1.12-1.51,1.12s-1.5-.43-1.5-1.12a1,1,0,0,1,.66-.92.86.86,0,0,1-.53-.81c0-.64.55-1,1.37-1s1.37.39,1.37,1a.86.86,0,0,1-.53.81A1,1,0,0,1,247.7,282.19Zm-.54,0c0-.41-.37-.67-1-.67s-1,.26-1,.67.36.7,1,.7S247.16,282.6,247.16,282.17Zm-1.8-1.69c0,.37.31.61.83.61s.84-.24.84-.61-.33-.61-.84-.61S245.36,280.1,245.36,280.48Z",
    id: "elfu7ey87gdpp",
    className: "animable",
    style: {
      transformOrigin: "246.195px 281.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,281.37c0-1.24.66-1.94,1.55-1.94s1.54.7,1.54,1.94-.66,1.94-1.54,1.94S248.2,282.6,248.2,281.37Zm2.55,0c0-1-.41-1.46-1-1.46s-1,.49-1,1.46.41,1.45,1,1.45S250.75,282.34,250.75,281.37Z",
    id: "el73704m04q3s",
    className: "animable",
    style: {
      transformOrigin: "249.745px 281.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,281.37c0-1.24.66-1.94,1.55-1.94s1.54.7,1.54,1.94-.66,1.94-1.54,1.94S251.81,282.6,251.81,281.37Zm2.55,0c0-1-.41-1.46-1-1.46s-1,.49-1,1.46.41,1.45,1,1.45S254.36,282.34,254.36,281.37Z",
    id: "elas3ppnm9b3",
    className: "animable",
    style: {
      transformOrigin: "253.355px 281.37px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.04,
    y: 259.39,
    width: 2.26,
    height: 4.41,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "551.17px 261.595px"
    },
    id: "elikmjjneyc2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.76,
    y: 257.24,
    width: 2.26,
    height: 6.56,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "554.89px 260.52px"
    },
    id: "elcwturp30atl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 256.07,
    width: 2.26,
    height: 7.73,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "558.61px 259.935px"
    },
    id: "elcn1a1jwkl49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,209.86c0,.14-23.89.26-53.35.26s-53.36-.12-53.36-.26,23.88-.26,53.36-.26S225.3,209.71,225.3,209.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.945px 209.86px"
    },
    id: "ele3d5b5ki4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,143.56c0,.14-23.72.26-53,.26s-53-.12-53-.26,23.71-.27,53-.27S225.1,143.41,225.1,143.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.1px 143.555px"
    },
    id: "elim503tia9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.13,125.77c0,.15-16.39.26-36.61.26s-36.61-.11-36.61-.26,16.39-.26,36.61-.26S235.13,125.63,235.13,125.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "198.52px 125.77px"
    },
    id: "el23w8q3ummm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.68 259.67 247.56 263.76 250.07 259.67 244.68 259.67",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "247.375px 261.715px"
    },
    id: "elvmjzxwr72l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,179.16c0,.14-11.39.26-25.44.26S157,179.3,157,179.16s11.39-.26,25.44-.26S207.88,179,207.88,179.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.44px 179.16px"
    },
    id: "el42xpkk2czdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,183.37h-8.42V175h8.42Zm-7.42-1h6.42V176h-6.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "140.57px 179.185px"
    },
    id: "elvibiho6p2vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,311.33c0,.14-11.39.26-25.44.26s-25.44-.12-25.44-.26,11.39-.26,25.44-.26S207.88,311.19,207.88,311.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.44px 311.33px"
    },
    id: "el95km3by7sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,315.54h-8.42v-8.42h8.42Zm-7.42-1h6.42v-6.42h-6.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "140.57px 311.33px"
    },
    id: "elw7u8mgzy2n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-62",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "86.0951px 365.545px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.23,370.23V359c-14,0-11.65-8.65-11.65-37.41,0-19.75.62-30.24-7.28-30.24-7.29,0-9,5.12-9,27.6C51.26,360.6,56.81,370.23,79.23,370.23Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "65.2649px 330.79px"
    },
    id: "el6trpyqrq1ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,404.92V393.71c14,0,11.65-8.64,11.65-37.41,0-19.75-.62-30.23,7.28-30.23,7.29,0,9,5.12,9,27.59C121.78,395.29,116.22,404.92,93.81,404.92Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.775px 365.495px"
    },
    id: "el9r3ab9yllva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1fsklw9zv9z"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "98.705px 399.015px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 393.19 100.89 404.5 97.08 404.84 96.52 393.58 98.71 393.19",
    id: "elefpux3vc4tk",
    className: "animable",
    style: {
      transformOrigin: "98.705px 399.015px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,255.89c-11.07,0-10.25,14.49-10.25,32.23V429.18h20.5V288.12C97.15,270.38,98,255.89,86.9,255.89Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "86.9007px 342.535px"
    },
    id: "elkfts6eljgrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,255.89c-11.07,0-10.25,14.49-10.25,32.23V429.18h20.5V288.12C97.15,270.38,98,255.89,86.9,255.89Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "86.9007px 342.535px"
    },
    id: "el57z4kq4k8qb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.94,429.63s0-.16,0-.45,0-.76,0-1.33c0-1.19,0-2.9,0-5.09,0-4.44.06-10.83.11-18.71.15-15.82.36-37.64.58-61.73s.55-45.92.74-61.74c.05-3.95.09-7.53.33-10.67a52,52,0,0,1,1.14-8,32.45,32.45,0,0,1,1.51-4.86c.21-.55.41-.94.53-1.22l.2-.4a4.49,4.49,0,0,1-.15.43c-.1.28-.29.68-.48,1.23A34.49,34.49,0,0,0,84,262a52.66,52.66,0,0,0-1,7.95c-.21,3.13-.23,6.7-.26,10.65-.14,15.82-.35,37.64-.58,61.74s-.54,45.92-.73,61.74c-.12,7.88-.21,14.26-.28,18.71-.05,2.19-.08,3.89-.1,5.08,0,.57,0,1,0,1.33S80.94,429.63,80.94,429.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.51px 342.53px"
    },
    id: "el1lu6ycn03zx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2,429.42a3.82,3.82,0,0,1,0-.45c0-.32,0-.75,0-1.31v-5.07c0-4.43,0-10.79.08-18.63.12-15.76.29-37.48.48-61.48s.46-45.72.62-61.48c0-3.93.08-7.48,0-10.6a68.71,68.71,0,0,0-.74-8,50.47,50.47,0,0,0-1-4.95c-.15-.54-.27-1-.36-1.27s-.1-.44-.1-.44a35.22,35.22,0,0,1,1.69,6.62,65.18,65.18,0,0,1,.83,8c.16,3.13.16,6.69.13,10.63-.12,15.75-.29,37.48-.47,61.48s-.47,45.72-.63,61.47c-.11,7.85-.19,14.21-.25,18.63,0,2.18-.07,3.88-.09,5.07,0,.56,0,1,0,1.31S90.2,429.42,90.2,429.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.5127px 342.58px"
    },
    id: "eloljqxjtqro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,404.73a32.57,32.57,0,0,1-.45-5.71A32.05,32.05,0,0,1,97,393.3a32,32,0,0,1,.46,5.71A30.4,30.4,0,0,1,97.36,404.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.1863px 399.015px"
    },
    id: "el19348mu1kc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,326.19a7.37,7.37,0,0,1,0,.81l.06,2.32c0,2.06.06,5,.1,8.52,0,7.24.1,17.16.16,28.12,0,5.48,0,10.76-1,15.47a25.25,25.25,0,0,1-5.21,11.48,17.24,17.24,0,0,1-6.77,5.14,11.33,11.33,0,0,1-3,.83,28.77,28.77,0,0,0,2.94-1,17.75,17.75,0,0,0,6.57-5.19,25.21,25.21,0,0,0,5-11.35c.94-4.64,1-9.89.94-15.37,0-11,0-20.88,0-28.12,0-3.56.05-6.46.06-8.52,0-1,0-1.74,0-2.32A3.93,3.93,0,0,1,113.29,326.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.62px 362.535px"
    },
    id: "el7zzch43zzed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,358.6a79.89,79.89,0,0,1,0,12.88,79.89,79.89,0,0,1,0-12.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.64px 365.04px"
    },
    id: "el4yjgzrcuo2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.76,291.39a4.09,4.09,0,0,1,0,.83c0,.58,0,1.37,0,2.35-.06,2.1-.15,5.05-.25,8.66-.22,7.32-.64,17.42-.5,28.58.14,5.57.09,10.92,1.25,15.6a26.23,26.23,0,0,0,5.4,11.41,16.1,16.1,0,0,0,7,4.81,19,19,0,0,0,3.08.67,9.61,9.61,0,0,1-3.14-.47,15.93,15.93,0,0,1-7.21-4.76,26.4,26.4,0,0,1-5.59-11.55c-1.2-4.75-1.17-10.14-1.3-15.71-.14-11.17.34-21.28.65-28.59.17-3.62.31-6.56.41-8.66.06-1,.1-1.76.14-2.35A4.06,4.06,0,0,1,59.76,291.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.1075px 327.846px"
    },
    id: "elg1sx9vaomut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzw5vq7mla1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "75.26px 364.325px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.86,370l.42-11.52,2.38.41,0,11.28S74.27,370.05,73.86,370Z",
    id: "elqk6ab166eyq",
    className: "animable",
    style: {
      transformOrigin: "75.26px 364.325px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,329.46a6.19,6.19,0,0,1-2.44.63,6,6,0,0,1-2.52.11,6.28,6.28,0,0,1,2.44-.62A6.28,6.28,0,0,1,53.49,329.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "51.01px 329.835px"
    },
    id: "elv8kgc41upch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.24,318.32a6.46,6.46,0,0,1-2.53-.24,6.43,6.43,0,0,1-2.42-.75,6.2,6.2,0,0,1,2.52.24A6.31,6.31,0,0,1,53.24,318.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "50.765px 317.823px"
    },
    id: "elrhzbeqpu8yq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.78,300.49a5,5,0,0,1,2.5,1.08c1.27.84,2.06,1.79,2,1.89A12.44,12.44,0,0,1,51,302,12.33,12.33,0,0,1,48.78,300.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "51.0316px 301.975px"
    },
    id: "elyn1r13v384j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,289.1a6.82,6.82,0,0,1,1.24,2.38,6.92,6.92,0,0,1,.74,2.57,7.23,7.23,0,0,1-1.23-2.38A7.36,7.36,0,0,1,56,289.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.99px 291.575px"
    },
    id: "elj62og6jg7jn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,289.86A11.49,11.49,0,0,1,64.77,293a11.45,11.45,0,0,1-1.84,2.85,11,11,0,0,1,1.38-3.1A11,11,0,0,1,66.15,289.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "64.54px 292.855px"
    },
    id: "el87r35viop0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.58,303.21a5.23,5.23,0,0,1-2.16.87,5.37,5.37,0,0,1-2.29.37,5.23,5.23,0,0,1,2.16-.87A5.37,5.37,0,0,1,69.58,303.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.355px 303.83px"
    },
    id: "elgy6rhjhgbcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.89,317.57c-.11.1-.75-.43-1.43-1.18s-1.15-1.44-1.05-1.54.75.44,1.43,1.19S64,317.48,63.89,317.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "62.6511px 316.21px"
    },
    id: "elascsoj4egbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.57,332a6.58,6.58,0,0,1-2-1.55c-1-1-1.77-1.82-1.67-1.93s1,.59,2,1.55S68.66,331.86,68.57,332Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.7342px 330.254px"
    },
    id: "el40g66dtj1n2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73,338.13a7.59,7.59,0,0,1-1.81,2.05c-1.09,1-2.06,1.77-2.16,1.66a7.48,7.48,0,0,1,1.81-2C53.66,338.77,54.63,338,54.73,338.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "52.745px 339.983px"
    },
    id: "elzqcmmqh1dwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46,350.76c-.14-.05,0-.92.37-1.94s.73-1.82.87-1.78a4,4,0,0,1-.37,1.94C57,350,56.6,350.8,56.46,350.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "57.0571px 348.9px"
    },
    id: "el2am85jed6gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.73,365.38a10.46,10.46,0,0,1,1.12-3.08,10.1,10.1,0,0,1,1.59-2.87,10.57,10.57,0,0,1-1.12,3.09A10.53,10.53,0,0,1,57.73,365.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "59.085px 362.405px"
    },
    id: "eluc87dw25hqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.17,372.06a8.28,8.28,0,0,1,.25-2.89,8.4,8.4,0,0,1,.76-2.8,16.25,16.25,0,0,1-1,5.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.6584px 369.215px"
    },
    id: "eli0gc4axydq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,350a5.81,5.81,0,0,1-2.41-.27,5.92,5.92,0,0,1-2.29-.77,5.7,5.7,0,0,1,2.41.26A5.66,5.66,0,0,1,70.59,350Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.24px 349.478px"
    },
    id: "elgtdgx1go97k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.58,341.35c0,.14-.93.09-2-.12s-2-.48-1.93-.62.94-.09,2,.11S69.61,341.21,69.58,341.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.6135px 340.98px"
    },
    id: "elvaqmmattg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrohlojv5fpk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "64.6255px 328.024px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.74,292c.35,0,.56,4.44.27,11.59-.13,3.57-.38,7.82-.66,12.52s-.6,9.87-.71,15.26a60,60,0,0,0,1.27,14.94,42.85,42.85,0,0,0,1.85,6.23,22.81,22.81,0,0,0,2.66,4.89,16.17,16.17,0,0,0,6.08,5.17c1.75.83,2.83,1.11,2.79,1.32s-1.17.21-3.16-.38a15.21,15.21,0,0,1-7.16-5,22.9,22.9,0,0,1-3.19-5.17,39.59,39.59,0,0,1-2.2-6.52A56.19,56.19,0,0,1,56,331.33c.11-5.49.52-10.68.92-15.38s.85-8.93,1.22-12.48C58.93,296.38,59.37,292,59.74,292Z",
    id: "ellqvp9cb0gtq",
    className: "animable",
    style: {
      transformOrigin: "64.6255px 328.024px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,377.49a5,5,0,0,1-2.26.26,5,5,0,0,1-2.25-.26,5.16,5.16,0,0,1,2.25-.26A5.19,5.19,0,0,1,107.59,377.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.335px 377.492px"
    },
    id: "elx6quja8eb5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,366.61a4.88,4.88,0,0,1-2.18-.21,4.79,4.79,0,0,1-2.07-.72,4.72,4.72,0,0,1,2.18.21A4.85,4.85,0,0,1,107.46,366.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.335px 366.143px"
    },
    id: "elp2se6murarh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,354.43a6.64,6.64,0,0,1-2.6.05,6.56,6.56,0,0,1-2.57-.48,6.8,6.8,0,0,1,2.61,0A6.81,6.81,0,0,1,108,354.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.415px 354.229px"
    },
    id: "elomkgwy5o79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.26,343.65a4.55,4.55,0,0,1-2-.62c-1.06-.48-1.88-1-1.82-1.1a4.55,4.55,0,0,1,2,.62C105.51,343,106.32,343.52,106.26,343.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "104.35px 342.79px"
    },
    id: "el3onlpn8pg24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.32,334.5a4.86,4.86,0,0,1-2.12-1.29c-1-.89-1.7-1.81-1.59-1.9s.91.64,1.93,1.51S107.4,334.37,107.32,334.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.462px 332.901px"
    },
    id: "elhn3oax1hbt6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,327.73c-.12.07-.65-.74-1.16-1.81s-.83-2-.7-2,.65.74,1.17,1.81S110.62,327.67,110.49,327.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.561px 325.827px"
    },
    id: "elc3iy9cqtt1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,325.35c.12.09-.38.88-1,1.85s-1.07,1.76-1.2,1.71.14-1,.75-2S119.44,325.26,119.54,325.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.433px 327.127px"
    },
    id: "elds8q88vncjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,337.28a4.89,4.89,0,0,1-2.43.59,4.8,4.8,0,0,1-2.48-.19,8.14,8.14,0,0,1,2.44-.33A8.49,8.49,0,0,1,123.78,337.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.325px 337.587px"
    },
    id: "el7mj0ac36slt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,345.91a6.2,6.2,0,0,1-2.08,1.41,6.1,6.1,0,0,1-2.31,1c-.07-.13.86-.76,2.07-1.41A6.05,6.05,0,0,1,123.65,345.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.453px 347.115px"
    },
    id: "elhnhcc193zih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.89,360c-.06.13-.91-.15-1.9-.63s-1.74-1-1.68-1.09.91.15,1.9.62S124,359.88,123.89,360Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.103px 359.147px"
    },
    id: "elzpavpe0pnsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,367.79c.06.13-.63.59-1.55,1s-1.71.69-1.77.56.63-.59,1.54-1S123,367.66,123.11,367.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.45px 368.57px"
    },
    id: "eltw7wenc7i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,384.25c-.11.09-.79-.48-1.52-1.29s-1.24-1.54-1.14-1.63.79.47,1.52,1.28S121.11,384.15,121,384.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.671px 382.79px"
    },
    id: "elx1f1yiywrfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.68,398.59A11.47,11.47,0,0,1,115,396a10.89,10.89,0,0,1-.6-2.6,5.28,5.28,0,0,1,1.1,2.47A5.18,5.18,0,0,1,115.68,398.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.092px 395.995px"
    },
    id: "elbic3qfno0gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,406a12.43,12.43,0,0,1,.36-5,6.21,6.21,0,0,1,.08,2.54A6.46,6.46,0,0,1,106,406Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.214px 403.5px"
    },
    id: "el4sxjhycxkrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,389.31a5.2,5.2,0,0,1-2.07-1c-1.06-.7-1.86-1.36-1.78-1.48s1,.35,2.07,1S105.54,389.19,105.46,389.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.535px 388.061px"
    },
    id: "elyqvzrhbqbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,363.43c-.1.11-.8-.33-1.57-1s-1.31-1.28-1.22-1.39.79.33,1.56,1S117.89,363.33,117.8,363.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.405px 362.235px"
    },
    id: "elt9lloiqxrwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,345.8c.1.1-.53.9-1.42,1.77s-1.68,1.5-1.78,1.4.53-.9,1.42-1.77S110.83,345.7,110.93,345.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.33px 347.385px"
    },
    id: "el9pmkxpy3e4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,332c.07.13-.54.61-1.37,1.08s-1.55.76-1.62.63.54-.61,1.36-1.08S118.38,331.83,118.46,332Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.965px 332.848px"
    },
    id: "elmc7scs52uu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.59,396.16c-.13,0-.52-.57-.88-1.4s-.53-1.54-.4-1.6.53.57.88,1.4S110.73,396.1,110.59,396.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.951px 394.658px"
    },
    id: "el1jregy7egfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,302.84a7.48,7.48,0,0,1-2.8.12,7.68,7.68,0,0,1-2.77-.41,7.85,7.85,0,0,1,2.8-.11A7.81,7.81,0,0,1,79.06,302.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.275px 302.701px"
    },
    id: "elrmyfmb49ytm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,286.76a7.19,7.19,0,0,1-2.59-.79,7.41,7.41,0,0,1-2.4-1.27,7.25,7.25,0,0,1,2.59.79A7.19,7.19,0,0,1,78.18,286.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.685px 285.73px"
    },
    id: "el5sfd8rsw7lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.65,266.8a4.75,4.75,0,0,1-2.8-.75,4.69,4.69,0,0,1-2.19-1.89c.1-.11,1.07.71,2.43,1.43S79.68,266.65,79.65,266.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.1553px 265.478px"
    },
    id: "elk6ipng1wiog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,257.48a7.11,7.11,0,0,1-1.52-2.25,7.32,7.32,0,0,1-1.06-2.49A7.11,7.11,0,0,1,82.28,255,7.32,7.32,0,0,1,83.34,257.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.05px 255.11px"
    },
    id: "el8fmk54tacww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,254.75a7.65,7.65,0,0,1-1.59,2.33c-1,1.2-1.89,2.1-2,2a7.65,7.65,0,0,1,1.6-2.34C95.05,255.55,95.94,254.65,96.05,254.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.255px 256.915px"
    },
    id: "els4sbbdkso9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.29,268.53c.08.12-.78.86-1.91,1.67a6.3,6.3,0,0,1-2.21,1.25c-.09-.12.77-.87,1.91-1.67A6.13,6.13,0,0,1,99.29,268.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.2293px 269.99px"
    },
    id: "elgbgom988v1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78,287.64a5.25,5.25,0,0,1-2.14.83,5.13,5.13,0,0,1-2.27.34,5.35,5.35,0,0,1,2.14-.84A5.21,5.21,0,0,1,100.78,287.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.575px 288.225px"
    },
    id: "elx9l4t5ndz48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.89,303.83a7.15,7.15,0,0,1-2.65.12,7.09,7.09,0,0,1-2.63-.4,7,7,0,0,1,2.66-.12A6.62,6.62,0,0,1,99.89,303.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.25px 303.688px"
    },
    id: "elukeyykvqwyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,320.21a8.92,8.92,0,0,1-2.51,1.7,9.19,9.19,0,0,1-2.77,1.24,8.74,8.74,0,0,1,2.51-1.7A9.19,9.19,0,0,1,100.19,320.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.55px 321.68px"
    },
    id: "elhskpelviwbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,328.18a8,8,0,0,1-2.84-.34A7.9,7.9,0,0,1,72,327a7.84,7.84,0,0,1,2.84.33A8,8,0,0,1,77.58,328.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.79px 327.588px"
    },
    id: "ele0yggowbwh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.13,342.45A9,9,0,0,1,76,344.58a9.27,9.27,0,0,1-2.5,1.73,9,9,0,0,1,2.17-2.13A9.27,9.27,0,0,1,78.13,342.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.815px 344.38px"
    },
    id: "ellqz1778zg0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.46,385.09a11.82,11.82,0,0,1-2.81-2,11.86,11.86,0,0,1-2.48-2.4,11.28,11.28,0,0,1,2.81,2A11.58,11.58,0,0,1,78.46,385.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.815px 382.89px"
    },
    id: "el777p2392svw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.89,397.1c.09.11-.69.92-1.74,1.82a6.27,6.27,0,0,1-2.08,1.41c-.09-.11.69-.92,1.74-1.81S77.79,397,77.89,397.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.98px 398.71px"
    },
    id: "el2p54jhy73yu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,370.36a8.82,8.82,0,0,1-2.2,2,8.63,8.63,0,0,1-2.51,1.55,8.53,8.53,0,0,1,2.2-2A8.21,8.21,0,0,1,99,370.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.645px 372.135px"
    },
    id: "el1otzk073gxz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.31,349.85a4.81,4.81,0,0,1-2.42,1.61,4.88,4.88,0,0,1-2.86.45A26.32,26.32,0,0,1,96.7,351C98.15,350.42,99.22,349.73,99.31,349.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.67px 350.899px"
    },
    id: "el59dr2jju0ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61,334.87a5.67,5.67,0,0,1-2.3-.64,5.54,5.54,0,0,1-2.1-1.12,5.6,5.6,0,0,1,2.29.64A5.64,5.64,0,0,1,99.61,334.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.41px 333.99px"
    },
    id: "elaovknxs3yd6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.75,410.84a9.53,9.53,0,0,1-2.68,1.55,9.57,9.57,0,0,1-2.9,1.08,9.26,9.26,0,0,1,2.68-1.55A9.26,9.26,0,0,1,100.75,410.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.96px 412.155px"
    },
    id: "elnds980nlxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,315.79a11.68,11.68,0,0,1-2.81-2.15,12.34,12.34,0,0,1-2.47-2.55,12.24,12.24,0,0,1,2.81,2.16A12.74,12.74,0,0,1,77.9,315.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.26px 313.44px"
    },
    id: "el536fio8fce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.36,308.18A8.58,8.58,0,0,1,99,310a8.84,8.84,0,0,1-2.64,1.4,9.08,9.08,0,0,1,2.36-1.84A8.8,8.8,0,0,1,101.36,308.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.86px 309.79px"
    },
    id: "eljc9ld0uq6jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,276.19a4.38,4.38,0,0,1-2.09,0c-1.14-.17-2-.41-2-.56a4.46,4.46,0,0,1,2.09,0C76.42,275.8,77.32,276.05,77.3,276.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.2552px 275.911px"
    },
    id: "elx1s3e2p3poc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6,277.36c.05.14-.83.58-2,1a4.69,4.69,0,0,1-2.15.49,5.08,5.08,0,0,1,2-1A5,5,0,0,1,99.6,277.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.526px 278.105px"
    },
    id: "el7qarddfigq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,312.31a8,8,0,0,1-1.57,2.36c-1,1.21-1.85,2.12-2,2a7.49,7.49,0,0,1,1.56-2.36C86.89,313.13,87.77,312.22,87.89,312.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.105px 314.492px"
    },
    id: "elvm5itlpk6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.86,297c-.07.11-1-.46-1.8-1.58a3.53,3.53,0,0,1-.84-2.24c.15,0,.55.92,1.27,2S88,296.91,87.86,297Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.5481px 295.097px"
    },
    id: "el24xsmslfoha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.57,275.31c.1.12-.72.9-1.51,2a17.34,17.34,0,0,1-1.42,2.09,4,4,0,0,1,1-2.39C86.48,275.84,87.49,275.2,87.57,275.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.1092px 277.349px"
    },
    id: "el8o7a4agz4cf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81,334.3a4.64,4.64,0,0,1,.49-2.14c.4-1.14.84-2,1-2a5,5,0,0,1-.49,2.14C86.38,333.47,85.94,334.35,85.81,334.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.5548px 332.231px"
    },
    id: "elrptocamb2ck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.51,365.73a13.44,13.44,0,0,1-1.86-3.25,13.81,13.81,0,0,1-1.4-3.48,13.92,13.92,0,0,1,1.87,3.25A13.54,13.54,0,0,1,82.51,365.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.88px 362.365px"
    },
    id: "elx7bhnbzaie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.39,370.66a16.64,16.64,0,0,1-1.69,3.78A16.94,16.94,0,0,1,84.55,378a33.05,33.05,0,0,1,3.84-7.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.47px 374.33px"
    },
    id: "elpeltmn7ymu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.11,404.17a12.15,12.15,0,0,1-1.86-3.1,12.82,12.82,0,0,1-1.4-3.34,12.49,12.49,0,0,1,1.86,3.1A13.26,13.26,0,0,1,88.11,404.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.48px 400.95px"
    },
    id: "el1zib6z87kduj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,414.42a6.88,6.88,0,0,1-1.25,2.34c-.81,1.22-1.56,2.14-1.68,2.06a7,7,0,0,1,1.25-2.35C85.23,415.26,86,414.34,86.1,414.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.635px 416.62px"
    },
    id: "elmgpx5owhftk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqq4g00g4wx"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "90.775px 343.855px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.77,259c.72,0,1.31,38,1.31,84.85s-.59,84.86-1.31,84.86-1.3-38-1.3-84.86S90.06,259,90.77,259Z",
    id: "elbz3a11rigl",
    className: "animable",
    style: {
      transformOrigin: "90.775px 343.855px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eldlo3vfidd9a"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "107.525px 363.081px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.32,327.48c.35,0,.78,4.34,1,11.36s.18,16.71.37,27.4a66.14,66.14,0,0,1-1.31,15.28,31.35,31.35,0,0,1-2.21,6.45,46.89,46.89,0,0,1-2.84,5.13,12.47,12.47,0,0,1-3.48,3.62,11.64,11.64,0,0,1-3.42,1.51c-2,.51-3.06.52-3.1.36s1-.54,2.75-1.31a12.71,12.71,0,0,0,2.92-1.74,11.45,11.45,0,0,0,2.76-3.41,53.24,53.24,0,0,0,2.44-5.05A31.42,31.42,0,0,0,112,381a72.94,72.94,0,0,0,1-14.75c-.19-10.72.15-20.43.39-27.43S114,327.49,114.32,327.48Z",
    id: "eljs00p25tdp",
    className: "animable",
    style: {
      transformOrigin: "107.525px 363.081px"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 57.15,
    y: 428.98,
    width: 58.76,
    height: 8.07,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.53px 433.015px"
    },
    id: "el36oxg0vt2v1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,437.16h-59v-8.28h59ZM57.25,437h58.56v-7.87H57.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.5px 433.02px"
    },
    id: "elvgl96zici3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.59 434.37 71.05 476.1 102.35 476.1 110.53 437.06 62.59 434.37",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.56px 455.235px"
    },
    id: "el7cct0i79iza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.59 472.15 67.11 478.35 105.15 478.35 110.53 472.15 62.59 472.15",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.56px 475.25px"
    },
    id: "elrotqq53zo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,437c0,.12-13.2.21-29.48.21s-29.48-.09-29.48-.21,13.19-.21,29.48-.21S116,436.91,116,437Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.52px 437px"
    },
    id: "eldhuw4nrzqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82,454c0,.11-8.89.21-19.86.21s-19.86-.1-19.86-.21S76,453.8,87,453.8,106.82,453.89,106.82,454Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.96px 454.005px"
    },
    id: "eltgagpqtjivj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,456.44c0,.11-8.74.2-19.52.2s-19.51-.09-19.51-.2,8.73-.21,19.51-.21S106.48,456.32,106.48,456.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.965px 456.435px"
    },
    id: "el2w96b9a0kx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.17,452c0,.12-9.2.21-20.54.21s-20.55-.09-20.55-.21,9.2-.2,20.55-.2S107.17,451.89,107.17,452Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "86.625px 452.005px"
    },
    id: "elcbbvxxtq58a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62",
    className: "animable",
    style: {
      transformOrigin: "650.069px 305.169px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.28,191.76l13.3-4.26,22-.55L659.9,191l6.39,62.41c.58,5.52-.75,12.23-4.85,16l-.19.21L616,269.08h0c-1.6,0-3.13-4.07-4-7l-2.2-19.45L608,235.43l-5.17,14.43-18.73,13.28s-4.8-4.85-2-18.61c1.7-8.5,7.8-24.19,12.21-34.94C594.3,209.59,597.35,195.59,609.28,191.76Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "623.821px 228.285px"
    },
    id: "elyaxton3guph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.06,257.12l-5.36-8.68L659.9,191s7.61,2.91,10.46,10.09c2.14,5.4,14.69,48.41,14.69,48.41",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "672.475px 224.06px"
    },
    id: "el0wh1zsr218jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.32,212c.14,0,1.56,6.42,3.17,14.41s2.79,14.48,2.65,14.51-1.56-6.42-3.16-14.41S603.18,212,603.32,212Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "606.23px 226.46px"
    },
    id: "elavexvxcistm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,246.24a25.56,25.56,0,0,0-3.61-1.67,13.67,13.67,0,0,0-16.39,6.3,23.69,23.69,0,0,0-1.55,3.66,3.29,3.29,0,0,1,.17-1.07,12.05,12.05,0,0,1,1.06-2.76,13.54,13.54,0,0,1,16.83-6.48,12,12,0,0,1,2.64,1.34A4.25,4.25,0,0,1,603,246.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "592.225px 248.938px"
    },
    id: "el4nmn3zr3fah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.76,209.55c.12,2.65.44,9.08.9,18.49.29,5.05.55,9.63.75,13.07.1,1.59.17,2.93.24,4a7.15,7.15,0,0,1,0,1.46,9.46,9.46,0,0,1-.23-1.44c-.11-.94-.25-2.28-.4-4-.3-3.34-.63-8-.9-13.07s-.43-9.74-.49-13.09A30,30,0,0,1,663.76,209.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "664.626px 228.06px"
    },
    id: "elyh0f53vthe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.43,269.37a3.53,3.53,0,0,1-1.37-.85,9.65,9.65,0,0,1-3.35-6.85,3.38,3.38,0,0,1,.17-1.6,15.81,15.81,0,0,0,1.27,5.14A16.17,16.17,0,0,0,631.43,269.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "629.055px 264.72px"
    },
    id: "elx89e1w3l358",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.15,255a6.45,6.45,0,0,1,.26,2.26,16.84,16.84,0,0,1-3.48,10.28,6.78,6.78,0,0,1-1.59,1.63A26.35,26.35,0,0,0,657,262.5,26.68,26.68,0,0,0,658.15,255Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "655.881px 262.085px"
    },
    id: "elsd5zmpuotk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.32,218.12a40.81,40.81,0,0,1-6.39-1.07,39.92,39.92,0,0,1-6.28-1.57,40.81,40.81,0,0,1,6.39,1.07A39.55,39.55,0,0,1,604.32,218.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "597.985px 216.8px"
    },
    id: "eldam93tl0x6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.49,220.31c0,.15-3-.58-6.56-1.35s-6.55-1.31-6.53-1.45a47.92,47.92,0,0,1,13.09,2.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "597.945px 218.92px"
    },
    id: "eliy7b0c9glx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.73,221.42a2.16,2.16,0,0,1-.59.05l-1.67.05-6.14.12c-5.18.12-12.34.36-20.23.85s-15,1.15-20.19,1.69l-6.11.64-1.66.17a2.32,2.32,0,0,1-.58,0,2.26,2.26,0,0,1,.57-.13l1.65-.26c1.43-.22,3.51-.5,6.09-.81,5.15-.63,12.29-1.34,20.19-1.84s15.08-.68,20.27-.7c2.59,0,4.69,0,6.14,0l1.67.05A4.07,4.07,0,0,1,663.73,221.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "635.145px 223.129px"
    },
    id: "el84qdveh4bfy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.06,223.6a2.45,2.45,0,0,1-.58.07l-1.67.11-6.15.32c-5.19.27-12.35.68-20.26,1.27s-15,1.24-20.23,1.74l-6.12.58-1.67.14a2.42,2.42,0,0,1-.59,0,2.39,2.39,0,0,1,.58-.12l1.65-.24c1.44-.2,3.53-.46,6.11-.75,5.17-.59,12.32-1.3,20.23-1.89s15.09-.94,20.29-1.12c2.6-.09,4.7-.14,6.15-.16h1.68A2.17,2.17,0,0,1,664.06,223.6Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "635.425px 225.698px"
    },
    id: "elmtqqzkgctwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.45,211.61a24,24,0,0,1-4.46,2.1,23.73,23.73,0,0,1-4.66,1.62,24,24,0,0,1,4.46-2.1A23.73,23.73,0,0,1,673.45,211.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "668.89px 213.47px"
    },
    id: "el0lc1b5hjf2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.42,213.06a31.18,31.18,0,0,1-5,2.76,31.68,31.68,0,0,1-5.23,2.29,31.75,31.75,0,0,1,5-2.76A32.09,32.09,0,0,1,674.42,213.06Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "669.305px 215.585px"
    },
    id: "elqr0oagzao3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmihmxpq12k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "605.59px 226.17px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.33,212.34c.07,4.37.21,9.35-.11,13.66s.11,10.91,3.17,14l1.66-4.82s-4.27-21-4.72-22.81",
    id: "elewuk7umxz9v",
    className: "animable",
    style: {
      transformOrigin: "605.59px 226.17px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el04q52epk7sdp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "655.909px 263.795px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653,269.53c2.71-3.3,4.91-7.25,5.31-11.5,1,1.08.27,3.14-.05,4.59a16.32,16.32,0,0,1-1.53,4.59c-.81,1.4-2.29,2.17-2.21,2.35",
    id: "ellezeyi5pjnp",
    className: "animable",
    style: {
      transformOrigin: "655.909px 263.795px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M623.79,426.36l-25,20.5,25.34,31.22c2.83-2.6-4.29-23.61-4.29-23.61L636.4,442Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "617.595px 452.22px"
    },
    id: "eloy1mxitjxjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp0f6w3vaaom"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "612.447px 444.949px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.37,443.71a1.65,1.65,0,0,0-2.17.3,1.58,1.58,0,0,0,.28,2.16,1.72,1.72,0,0,0,2.29-.33,1.63,1.63,0,0,0-.53-2.21",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "612.447px 444.949px"
    },
    id: "elszy8j8d9d9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9w835cthxlp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "611.823px 461.445px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.9,446.77l2.51-2.08,23.22,31s.51,1.88-.6,2.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "611.823px 461.445px"
    },
    id: "elek31988eusb",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M620.42,454.84c-.15.12-.84-.58-1.94-.94s-2.07-.23-2.12-.42,1-.67,2.34-.23S620.59,454.76,620.42,454.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "618.404px 453.962px"
    },
    id: "elceuegkj5gle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.73,459.22c-.12.15-.92-.3-2-.29s-1.87.41-2,.25.67-.95,2-.94S621.87,459.1,621.73,459.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "619.731px 458.745px"
    },
    id: "elhzr9p1l12fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.32,464.26c-.15-.11.44-.95,1.59-1.23s2.07.16,2,.32-.88.09-1.82.34S619.45,464.4,619.32,464.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "621.105px 463.612px"
    },
    id: "eld41j3df4hou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.88,451.58c-.19.05-.55-.82-1.31-1.63s-1.57-1.27-1.51-1.46,1.14,0,2,1S624.06,451.56,623.88,451.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "622.503px 450.003px"
    },
    id: "elm37g4jsmk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,447.83c-.06.05-.65-.47-1.26-1.57a9.1,9.1,0,0,1-.83-2,10.16,10.16,0,0,1-.25-1.29,2.43,2.43,0,0,1,0-.77.85.85,0,0,1,.75-.73,1.1,1.1,0,0,1,.89.39,2.54,2.54,0,0,1,.39.65,7.54,7.54,0,0,1,.46,1.24,7.16,7.16,0,0,1,.22,2.21,3.35,3.35,0,0,1-.52,1.95c-.11,0,.09-.76,0-1.95a7.45,7.45,0,0,0-.8-3.16c-.18-.4-.4-.68-.62-.65s-.11,0-.15.18a1.88,1.88,0,0,0,0,.57,11.33,11.33,0,0,0,.19,1.21,11.79,11.79,0,0,0,.65,2A14.26,14.26,0,0,1,627,447.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "626.005px 444.689px"
    },
    id: "elxyokgv4xlw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.6,447.81c-.07,0,.23-.78,1.17-1.64a6.65,6.65,0,0,1,1.89-1.17,7,7,0,0,1,1.27-.38,1.68,1.68,0,0,1,1.6.36,1,1,0,0,1,.1,1,2.84,2.84,0,0,1-.45.62,4.41,4.41,0,0,1-1,.86,4.57,4.57,0,0,1-2.16.64,2.62,2.62,0,0,1-2-.49c0-.12.76.17,1.92,0a4.65,4.65,0,0,0,1.87-.7,3.91,3.91,0,0,0,.88-.76c.29-.32.46-.66.32-.76a1.19,1.19,0,0,0-1-.13,6.79,6.79,0,0,0-1.16.3,7.27,7.27,0,0,0-1.81,1C627.13,447.25,626.69,447.87,626.6,447.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "629.655px 446.343px"
    },
    id: "eln6rrd5ctbmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.67,446l.31,32.32,40.21-.17c-.26-3.84-21.09-11.46-21.09-11.46l.66-20.72Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "632.93px 462.145px"
    },
    id: "elu3db3c4toyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpy69gs3m4m"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "620.052px 466.484px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.66,465a1.64,1.64,0,0,0-1.13,1.88,1.58,1.58,0,0,0,1.85,1.13,1.74,1.74,0,0,0,1.19-2,1.63,1.63,0,0,0-2.06-1",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "620.052px 466.484px"
    },
    id: "elyahymjerv7k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9psq4cgca0c"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "633.134px 476.615px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613,478.22l0-3.26,38.67,1.31s1.79.78,1.58,2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "633.134px 476.615px"
    },
    id: "elfbzg0u4y0q5",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M632.75,466.51c0,.2-1,.29-2,.92s-1.47,1.47-1.66,1.39.11-1.21,1.29-2S632.79,466.33,632.75,466.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "630.894px 467.563px"
    },
    id: "eln8bbdhkiv3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,468.24c0,.19-.81.52-1.47,1.36s-.85,1.71-1,1.7-.32-1.12.52-2.14S637,468.05,637,468.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "635.703px 469.73px"
    },
    id: "eliga7nsly34d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.39,473.27c-.18.05-.45-.93.05-2s1.41-1.51,1.5-1.35-.49.74-.88,1.63S639.59,473.25,639.39,473.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "640.052px 471.58px"
    },
    id: "el0823t62vzua6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.38,461.77c-.09.18-1-.09-2.1,0s-2,.44-2.07.27.72-.87,2-.95S632.47,461.62,632.38,461.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "630.296px 461.584px"
    },
    id: "el2u9gsqm2tuv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.4,457a3.84,3.84,0,0,1-2,0,9,9,0,0,1-2.1-.63,8.61,8.61,0,0,1-1.16-.61,2.44,2.44,0,0,1-.61-.47.86.86,0,0,1-.1-1.05,1.09,1.09,0,0,1,.86-.45,2.8,2.8,0,0,1,.76.1,8,8,0,0,1,1.25.42,7,7,0,0,1,1.86,1.22c.94.86,1.26,1.59,1.19,1.63s-.54-.55-1.5-1.26a8.13,8.13,0,0,0-1.8-1,7.73,7.73,0,0,0-1.15-.35c-.43-.11-.79-.11-.9.08s0,.1,0,.23a2.17,2.17,0,0,0,.44.34,10.58,10.58,0,0,0,1.07.6,10.72,10.72,0,0,0,2,.74A13.56,13.56,0,0,1,631.4,457Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "628.348px 455.476px"
    },
    id: "elu1vqkezlz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.14,457.29a3.21,3.21,0,0,1-.54-1.94,6.58,6.58,0,0,1,.78-3.44,1.67,1.67,0,0,1,1.28-1,1,1,0,0,1,.84.56,2.61,2.61,0,0,1,.21.74,4.37,4.37,0,0,1,0,1.35,4.65,4.65,0,0,1-.85,2.09c-.78,1-1.6,1.28-1.62,1.22s.62-.49,1.21-1.49a4.49,4.49,0,0,0,.63-1.89,4.2,4.2,0,0,0,0-1.17c-.06-.42-.23-.77-.38-.72s-.54.32-.71.66a7.47,7.47,0,0,0-.49,1.09,7,7,0,0,0-.38,2C631,456.52,631.25,457.26,631.14,457.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "632.177px 454.1px"
    },
    id: "eldzvhurtdb8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,269.08s-5.35,5.73-8,11.22-4.3,18.59-4.3,18.59-7.39,16.46-6.27,24.88,8.65,66,8.65,66-.37,56,5,66l1.18,5.39,21.53-3.82h0l1.21-3,3.28-110,13.41-74.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "624.502px 365.12px"
    },
    id: "el6zyc6zueuon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.44,269.63l1.19,5.92s4.73,5.58,5.39,12.38,1.75,27.74,1.75,27.74l-2,5.21s5,3.72,5.82,6.16,14.82,67,12.95,70.83-51.69,50.89-51.69,50.89L620.64,430l25.9-29.57,6.87-3.12,1.42-6-1.59-3.79-.11-6.25-17.08-36.74,1.36-31.62,10.69-43.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "653.676px 359.11px"
    },
    id: "elpwywj42gvke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.65,291.57a3.43,3.43,0,0,1-.14-.88c-.06-.57-.1-1.39-.11-2.41a69.94,69.94,0,0,1,.47-7.92c.35-3,.67-5.7.92-7.87a25.57,25.57,0,0,1,.42-3.25,17.44,17.44,0,0,1-.06,3.29c-.13,2-.43,4.81-.76,7.88s-.56,5.86-.62,7.88S625.74,291.56,625.65,291.57Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "626.33px 280.405px"
    },
    id: "el04m3g920dg9y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.64,278.32a14.4,14.4,0,0,1-1.07-4.45,14.11,14.11,0,0,1-.12-4.58,35,35,0,0,1,.63,4.51A33.07,33.07,0,0,1,629.64,278.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "628.979px 273.805px"
    },
    id: "el4td8jcbdrnw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.72,317.71a6.4,6.4,0,0,1-.1,1.28l-.44,3.48c-.38,2.93-.89,7-1.38,11.46s-.85,8.55-1.1,11.5c-.13,1.39-.23,2.56-.31,3.49a6.47,6.47,0,0,1-.18,1.27,6.17,6.17,0,0,1,0-1.29c0-.82.07-2,.15-3.5.16-2.95.47-7,1-11.52s1.05-8.54,1.52-11.46c.24-1.47.45-2.65.61-3.46A5.69,5.69,0,0,1,641.72,317.71Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "639.949px 333.95px"
    },
    id: "elq2e10fydxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.76,269.51a11.08,11.08,0,0,1,0,1.62c-.05,1-.14,2.54-.27,4.4-.27,3.71-.69,8.84-1.25,14.49s-1.14,10.77-1.61,14.46c-.23,1.85-.44,3.34-.59,4.37a9.05,9.05,0,0,1-.29,1.6,9.33,9.33,0,0,1,.09-1.62c.11-1.13.25-2.6.42-4.39.39-3.79.9-8.86,1.46-14.47s1-10.68,1.4-14.47c.18-1.78.33-3.26.44-4.39A8.72,8.72,0,0,1,646.76,269.51Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "644.768px 289.98px"
    },
    id: "eli5vv1e8m4hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.46,273.9c-.09,0-.06-.71-.82-1.24a1.61,1.61,0,0,0-1.48-.15,1.54,1.54,0,1,0,1.52,2.65,2.45,2.45,0,0,0,.78-1.26s.09.15.06.45a1.79,1.79,0,0,1-.61,1.1,1.93,1.93,0,0,1-1.86.37,2,2,0,0,1-.06-3.76,1.93,1.93,0,0,1,1.86.3,1.72,1.72,0,0,1,.65,1.08C643.54,273.74,643.49,273.9,643.46,273.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "641.614px 273.93px"
    },
    id: "elvy9mjskdnrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.4,329.66c-.09,0-.22-1.2-.67-3.1a30.32,30.32,0,0,0-7-13.32c-1.31-1.45-2.23-2.25-2.17-2.32a3.33,3.33,0,0,1,.71.49A21,21,0,0,1,633,313a26.76,26.76,0,0,1,7.09,13.5,19.26,19.26,0,0,1,.31,2.32A2.42,2.42,0,0,1,640.4,329.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "635.497px 320.29px"
    },
    id: "elhy32mh66v8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.77,391.13s-.17.21-.53.52a11.19,11.19,0,0,1-1.68,1.12,14,14,0,0,1-2.77,1.18,16.31,16.31,0,0,1-3.62.65,16.75,16.75,0,0,1-3.68-.22,14.46,14.46,0,0,1-2.89-.86,10.62,10.62,0,0,1-1.79-.92c-.4-.27-.61-.42-.59-.46s.94.48,2.52,1a15.49,15.49,0,0,0,2.83.72,16.53,16.53,0,0,0,7.09-.41,16.48,16.48,0,0,0,2.73-1C671.89,391.71,672.71,391.05,672.77,391.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "663.994px 392.872px"
    },
    id: "elfzc9z6v0x4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.63,397.57a29.06,29.06,0,0,1-5.44.15,28.57,28.57,0,0,1-5.44-.36,56,56,0,0,1,10.88.21Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "658.19px 397.487px"
    },
    id: "elm7x56gj0utk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.71,395.33a3.13,3.13,0,0,1,0,.6c0,.45,0,1,0,1.72,0,1.5,0,3.66-.1,6.33-.12,5.34-.42,12.72-.77,20.86s-.59,15.52-.7,20.86c-.06,2.62-.1,4.77-.13,6.33,0,.7,0,1.27,0,1.72a2.87,2.87,0,0,1,0,.6,2.2,2.2,0,0,1-.05-.6c0-.45,0-1,0-1.72,0-1.5-.05-3.66,0-6.33,0-5.35.2-12.73.55-20.88s.68-15.45.92-20.85c.11-2.62.2-4.76.27-6.32,0-.7.07-1.27.09-1.72A2.66,2.66,0,0,1,636.71,395.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "635.864px 424.84px"
    },
    id: "elpq9zfomk2ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.29,247.35a13.93,13.93,0,0,0-10.85,8.31c-1.11,2.62-1.65,5.43-.32,7.48,3.3,5.09,7.87,4.58,12.3,2.79s36-13.51,36-13.51l-2.61-10.1Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "607.879px 254.754px"
    },
    id: "el5sf293bj3i6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654,237.8l-7.07,1.25-3,1.84s.68-.86,1.26-1.74a24.89,24.89,0,0,1,2.93-2.89l5.26-1s3-.48,3-2.55l-4.08,0s4.16-.65,3.89-2.74l-3.12-.28a1,1,0,0,0,.87-1.2l-8.54-.23-7.6,6.43-7.23,7.57-1.75.23.34,11.34s6.87-1.44,8.68-2.54,9.57-9.4,9.57-9.4,4.37-.76,5.5-1.91A3.27,3.27,0,0,0,654,237.8Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "642.6px 241.045px"
    },
    id: "el6b3spfgv7qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.45,254.1s0,0,.11,0l.32-.05,1.26-.25c1.11-.23,2.72-.57,4.77-1.1a30.18,30.18,0,0,0,3.37-1.05,5.91,5.91,0,0,0,1.68-1.13c.52-.45,1-.94,1.58-1.46,2.15-2.06,4.49-4.47,7-7.15l-.09,0a23.62,23.62,0,0,0,3.92-1,6.55,6.55,0,0,0,1-.44,4.8,4.8,0,0,0,.48-.3l.22-.19.19-.21a4.28,4.28,0,0,0,.63-.92,2.8,2.8,0,0,0,.32-1.14v-.21l-.22,0-7.07,1.24h0l0,0-3,1.83.25.29.9-1.24.45-.62a6.69,6.69,0,0,1,.5-.58c.71-.74,1.51-1.46,2.32-2.16l-.09,0,3.16-.59,1.62-.31c.27-.06.55-.1.83-.17a5.62,5.62,0,0,0,.82-.27,3.75,3.75,0,0,0,1.34-.89,2.16,2.16,0,0,0,.62-1.5v-.2h-.19l-4.08-.05,0,.39a9.08,9.08,0,0,0,2.54-.81,3.41,3.41,0,0,0,1.09-.81,1.7,1.7,0,0,0,.42-1.33l0-.16h-.16l-3.29-.2,0,.38a1.59,1.59,0,0,0,.87-.47,1.16,1.16,0,0,0,.27-1l0-.16h-.15l-8.48-.27h-.07l0,.05-7.59,6.44h0l-7.2,7.61.07,0-7.17,1-1.91.28-.48.08-.17,0H621l.49-.05,1.91-.23,7.19-.9h0l0,0,7.25-7.55h0l7.62-6.4-.12,0,8.48.3-.19-.16a.78.78,0,0,1-.17.66,1.32,1.32,0,0,1-.66.35l-1.37.29,1.4.09,3.29.19-.18-.16a1.3,1.3,0,0,1-.34,1,3,3,0,0,1-1,.71,8.73,8.73,0,0,1-2.43.77l0,.4,4.08,0-.19-.2a1.81,1.81,0,0,1-.52,1.24,3.44,3.44,0,0,1-1.2.79,4.32,4.32,0,0,1-.77.25c-.25.07-.53.11-.8.17l-1.63.31-3.15.59h-.06l0,0c-.81.71-1.61,1.43-2.35,2.19-.18.2-.36.4-.52.61l-.46.64-.88,1.22-.58.8.83-.52,3-1.84-.06,0,7.06-1.26-.21-.18a2.55,2.55,0,0,1-.28,1,3.76,3.76,0,0,1-.58.85,4.11,4.11,0,0,1-1.72,1.05,23.72,23.72,0,0,1-3.86,1h0l0,0c-2.52,2.69-4.85,5.11-7,7.18-.53.52-1.05,1-1.57,1.47a5.52,5.52,0,0,1-1.6,1.1,30.93,30.93,0,0,1-3.32,1.08c-2,.55-3.65.92-4.75,1.18l-1.25.3-.31.08Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "638.8px 240.97px"
    },
    id: "eleanqd80xifd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.25,237a7.83,7.83,0,0,0,1.37-1c.81-.68,1.92-1.63,3.13-2.69l.33-.3L647,233c1.5-.06,2.85-.14,3.82-.22a6.67,6.67,0,0,0,1.55-.2,6.2,6.2,0,0,0-1.56-.07c-1,0-2.32,0-3.83.1h-.07l0,.05-.34.29c-1.2,1.07-2.28,2.05-3.05,2.77A7.44,7.44,0,0,0,642.25,237Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "647.31px 234.745px"
    },
    id: "el3y66vt1eoq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.83,233.14a6.77,6.77,0,0,0,1.26-.93c.74-.62,1.77-1.5,2.9-2.5l-.13,0h.47c1.63,0,3.09,0,4.16,0a7.29,7.29,0,0,0,1.72-.11,7.58,7.58,0,0,0-1.72-.17c-1.06-.06-2.53-.11-4.15-.14h-.56l0,.06c-1.13,1-2.12,1.91-2.82,2.58A5.83,5.83,0,0,0,642.83,233.14Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "648.02px 231.215px"
    },
    id: "eld7ltmvjmgyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.31,166.28a67.71,67.71,0,0,1-3.25-11.12,23.39,23.39,0,0,1,.58-11.46c.19-.56,1.82-4.29,2.4-4.25.42,0-.55,3.5-.33,3.85a19.8,19.8,0,0,1,2.58,11.53,51.82,51.82,0,0,1-2,11.45",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "621.482px 152.865px"
    },
    id: "elq5k3ano5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.69,198.19a11,11,0,0,1-11.11-10.69l-1.09-36.06c-.6-9.68,4.53-18.1,14.22-18.43l.9,0a17.34,17.34,0,0,1,16.9,16.35c.47,8.39.88,17.67.72,22.16-.34,9.3-9.68,10.52-9.68,10.52s0,2.16.07,4.89a11,11,0,0,1-10.93,11.24Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "637.854px 165.6px"
    },
    id: "ela2lc5180ybr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.56,182.18a22.48,22.48,0,0,1-12-3.88s2.79,6.84,12.09,6.23Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "638.605px 181.434px"
    },
    id: "ellilzr1zwia9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,167.14a2,2,0,1,1,2.21,3.23,2.54,2.54,0,0,1-1.61,0,2,2,0,0,1-1-.65,1.77,1.77,0,0,1-.15-1.7,2.68,2.68,0,0,1,.88-1.17",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "639.373px 168.511px"
    },
    id: "elenv2xopqi97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.05,156.57a1.33,1.33,0,0,1-1.32,1.31,1.27,1.27,0,0,1-1.34-1.23,1.34,1.34,0,0,1,1.32-1.31A1.27,1.27,0,0,1,651.05,156.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "649.72px 156.61px"
    },
    id: "el9ir5r4smca9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.44,153.91c-.17.17-1.16-.6-2.59-.63s-2.49.66-2.65.48.11-.39.57-.71a3.68,3.68,0,0,1,2.12-.6,3.61,3.61,0,0,1,2.06.72C651.38,153.52,651.52,153.84,651.44,153.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "648.808px 153.191px"
    },
    id: "els7ou1g7emki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.77,156.52a1.33,1.33,0,0,1-1.32,1.3,1.26,1.26,0,0,1-1.34-1.23,1.34,1.34,0,0,1,1.32-1.31A1.28,1.28,0,0,1,637.77,156.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "636.44px 156.551px"
    },
    id: "elk3jt1dx0b2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.68,153.92c-.17.17-1.16-.6-2.59-.63s-2.49.66-2.64.48.1-.38.56-.71a3.68,3.68,0,0,1,2.12-.6,3.58,3.58,0,0,1,2.06.72C637.62,153.53,637.76,153.85,637.68,153.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "635.054px 153.201px"
    },
    id: "el2xqdtfam844",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.27,164.66a8.91,8.91,0,0,1,2.34-.37c.36,0,.71-.09.78-.34a1.87,1.87,0,0,0-.22-1.09l-1-2.8c-1.41-4-2.41-7.28-2.25-7.33s1.43,3.14,2.83,7.13l1,2.82a2.11,2.11,0,0,1,.15,1.44.92.92,0,0,1-.61.52,3,3,0,0,1-.62.07A9.81,9.81,0,0,1,642.27,164.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "643.934px 158.745px"
    },
    id: "eldzkzp2t4n2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,165.54c.24,0,.2,1.55,1.5,2.68s3,1,3,1.22-.38.29-1.08.29a3.79,3.79,0,0,1-2.47-.93,3.33,3.33,0,0,1-1.16-2.24C637.75,165.91,637.94,165.53,638,165.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "640.142px 167.635px"
    },
    id: "ela09ruutkud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.85,148.34c-.16.38-1.58.16-3.26.32s-3.05.59-3.26.24c-.1-.17.15-.53.7-.9a5.52,5.52,0,0,1,2.44-.78,5.3,5.3,0,0,1,2.53.36C637.61,147.84,637.91,148.15,637.85,148.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "634.583px 148.113px"
    },
    id: "el2amx16mqbkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651,149.85c-.26.32-1.23,0-2.42-.09s-2.19.17-2.41-.17c-.1-.17.07-.49.51-.79a3.29,3.29,0,0,1,2-.48,3.34,3.34,0,0,1,1.92.69C651,149.36,651.09,149.7,651,149.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "648.587px 149.149px"
    },
    id: "el3vvhiob3tcv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.09,158.45c-.16-.07-6.35-2-6.3,4.32s6.43,5,6.44,4.82S622.09,158.45,622.09,158.45Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "619.01px 162.972px"
    },
    id: "elir5stahsoai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.27,165.2s-.11.08-.3.16a1.09,1.09,0,0,1-.83,0,2.76,2.76,0,0,1-1.29-2.45,3.67,3.67,0,0,1,.3-1.59,1.27,1.27,0,0,1,.83-.86.55.55,0,0,1,.65.3c.09.17,0,.3.09.31s.13-.11.08-.37a.69.69,0,0,0-.26-.39.78.78,0,0,0-.61-.16,1.56,1.56,0,0,0-1.15,1,3.81,3.81,0,0,0-.37,1.78,2.89,2.89,0,0,0,1.64,2.74,1.19,1.19,0,0,0,1-.18C620.26,165.35,620.29,165.21,620.27,165.2Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "618.841px 162.925px"
    },
    id: "elnu4slmvpxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.42,139.15c1-.59-2.33-4-4.88-5.1-3.86-1.68-9.71-2.65-13.22-1.59-4.23,1.28-7.72,3.45-9.79,7.35a25.06,25.06,0,0,0-2.6,12.82,7.7,7.7,0,0,0,1,3.88c.91,1.37,2.6,2.23,2.6,4.12a2.78,2.78,0,0,0,.6,1.9c1.2,1.38,2.66.16,3.31-1.05,1.36-2.5,1.47-5.47,1.54-8.32a27.49,27.49,0,0,0-.42-6.79,7.11,7.11,0,0,1-.26-2.15,6.23,6.23,0,0,1,1-3.34,4.28,4.28,0,0,1,.57-.59,5.72,5.72,0,0,1,5.59-1c3.63,1.2,6.56,3.18,10.71,1.4a5.25,5.25,0,0,0,1.78-1.6,1.85,1.85,0,0,1,2.51,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "634.24px 147.58px"
    },
    id: "ely7o14yz8gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.2,169.87s.07.14-.06.34a1.17,1.17,0,0,1-.84.43,2.2,2.2,0,0,1-1.33-.29,2.23,2.23,0,0,1-1-1.33,2.36,2.36,0,0,1,.14-1.67,2.32,2.32,0,0,1,.92-1c.69-.38,1.19-.28,1.18-.23s-.44.14-1,.54a2.07,2.07,0,0,0-.77,2.22,1.94,1.94,0,0,0,1.84,1.39,1.18,1.18,0,0,0,.71-.19C622.12,170,622.16,169.86,622.2,169.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "620.549px 168.36px"
    },
    id: "elf43ukpo8w8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.39,265.44c.13.05-.19,1.1-1.1,2.07s-1.94,1.36-2,1.23.78-.69,1.61-1.59S659.26,265.38,659.39,265.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "657.852px 267.101px"
    },
    id: "el4cpbd27vd6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.2,250.13l54.29-3.52a1.8,1.8,0,0,0,1.63-1.36l7.74-31a1.8,1.8,0,0,0-1.78-2.24l-33.91.55a1.8,1.8,0,0,0-1.72,1.36l-7.79,31.32a1.78,1.78,0,0,1-1.56,1.35l-18.74,2A1.67,1.67,0,0,0,655.2,250.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "686.137px 231.074px"
    },
    id: "el03mosq87n1fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.15,213.56s-.19.08-.51.27a3.32,3.32,0,0,0-1.07,1.2c-.72,1.24-1,3.33-1.7,5.81L677,240.33c-.5,1.9-.92,3.75-1.46,5.55a3.52,3.52,0,0,1-.73,1.25,2.72,2.72,0,0,1-1.25.69,15.25,15.25,0,0,1-2.63.27l-9,.51-6.08.31-1.65.07a2.34,2.34,0,0,1-.58,0l.57-.07,1.65-.14,6.08-.43,9-.59a14.53,14.53,0,0,0,2.56-.27,2.31,2.31,0,0,0,1.08-.6,3.05,3.05,0,0,0,.64-1.11c.52-1.74.94-3.64,1.44-5.53l5-19.45.89-3.36a9.44,9.44,0,0,1,.94-2.46,3.2,3.2,0,0,1,1.16-1.19A1.9,1.9,0,0,1,685.15,213.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "669.385px 231.279px"
    },
    id: "elcilpbbtf0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.61,212.81l-.34,0-1,0-3.58.08c-3,.06-7.21.2-11.83.36s-8.8.29-11.83.32c-1.51,0-2.74,0-3.59,0l-1,0c-.22,0-.34,0-.34,0l.34,0,1,0,3.59-.12,11.82-.42c4.62-.17,8.8-.26,11.83-.26,1.52,0,2.74,0,3.59,0l1,0C718.49,212.78,718.61,212.79,718.61,212.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "701.855px 213.17px"
    },
    id: "el6j12udbq5zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.77,218.62a1,1,0,0,1,.86,1.07,1,1,0,1,1-.86-1.07",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "700.633px 219.611px"
    },
    id: "elns6kvp2uj5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.39,247.46l-30.67,1.93h0s3.4,12.27,10.49,13.53c6.57,1.17,21.69-12.9,21.69-12.9Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "681.81px 255.225px"
    },
    id: "el76lzcxt35f4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,248.88s2-2.71,3.38-2.69,5-.46,5-.46a11.94,11.94,0,0,0,2.68-2.51c.9-1.31,2.11-2.8,2.67-2.51s.77.46.25,1.66-1.76,3.62-1.76,3.62l1.25.14s2.13-6.17,3.81-5.9c0,0,.76.54.61,1.19,0,0,1.09-1.73,1.56-1.3s.29,2,0,3.49-.59,2.51-.59,2.51l1.3-.27s3.75-6,4.62-5.78.74,1.28.35,2.05-2.54,4.53-2.54,4.53-6,2.49-7.18,2.88S688.4,254,688.4,254Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "696.716px 247.026px"
    },
    id: "elhk6g960gl1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.29,250.77c-.08.1-.69-.3-1-1.12a1.68,1.68,0,0,1,0-1.14c.11-.28.28-.39.33-.35s-.09.62.21,1.31S685.4,250.67,685.29,250.77Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "684.753px 249.469px"
    },
    id: "el9654l8zr3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.41,257.1a4.19,4.19,0,0,1,.52-2,10,10,0,0,1,3.22-3.86,16.43,16.43,0,0,1,4.49-2.23,7.12,7.12,0,0,1,2-.53,9.66,9.66,0,0,1-1.87.87,20.87,20.87,0,0,0-4.32,2.31,11,11,0,0,0-3.2,3.6C674.67,256.34,674.49,257.12,674.41,257.1Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "679.525px 252.79px"
    },
    id: "elcu7sbc2gzso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.27,245.93c.08.12-.82.83-2.11,1.36a4.46,4.46,0,0,1-2.45.51,9.85,9.85,0,0,1,2.25-1A10.22,10.22,0,0,1,696.27,245.93Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "693.992px 246.872px"
    },
    id: "el5jt2pn0omev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.15,241.27a8.34,8.34,0,0,1-.28,1.48,9.3,9.3,0,0,1-1.17,3.53,5.58,5.58,0,0,1-3.18,2,3.65,3.65,0,0,1-1.51.23,5.57,5.57,0,0,1,1.4-.58,5.94,5.94,0,0,0,2.86-1.91,11.52,11.52,0,0,0,1.24-3.32C701.78,241.75,702.09,241.24,702.15,241.27Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "699.08px 244.893px"
    },
    id: "elsveenqkog5g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-62",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "368.67px 478.35px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.59,478.35c0,.15-145.93.26-325.9.26s-325.94-.11-325.94-.26,145.9-.26,325.94-.26S694.59,478.21,694.59,478.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.67px 478.35px"
    },
    id: "elauo26j9cfe",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.7f553d9eaa34d86433b45917d6d8d002.svg";
export { ForwardRef as ReactComponent };